(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bespoke-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bespoke-journey')) {
    customElements.define('bespoke-journey', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.chapters = Array.from(this.querySelectorAll('[data-chapter]'));
        this.navigation = this.querySelector('.bespoke-journey__navigation');
        this.returnTop = this.querySelector('[data-return-top]');
        this.film = this.querySelector('video');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.wheelTotal = 0;
        this.lastWheel = 0;
        this.gestureLockedUntil = 0;
        this.groups = Array.from(this.querySelectorAll('[data-choice-group]'));
        this.mobileViewport = matchMedia('(max-width: 767px)');
        this.mobile = this.mobileViewport.matches;
        this.scrolling = this.dataset.layout === 'scroll' || this.mobile;
        this.dataset.mobile = String(this.mobile);
        this.reading = this.dataset.editor === 'true';
        this.groups.forEach(group => {
          group.dataset.selected = group.querySelector('[data-choice]')?.dataset.choice || '';
          const gallery = group.querySelector('.bespoke-journey__choice-images');
          gallery?.addEventListener('scroll', () => {
            if (!this.mobile || this.reading || group.swipeFrame) return;
            group.swipeFrame = requestAnimationFrame(() => { group.swipeFrame = null; this.syncGarmentSwipe(group); });
          }, { signal, passive: true });
          const releaseGarmentTarget = () => { group.garmentTarget = null; };
          ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(type => gallery?.addEventListener(type, releaseGarmentTarget, { signal, passive: true }));
          gallery?.addEventListener('scrollend', () => { releaseGarmentTarget(); this.syncGarmentSwipe(group); }, { signal, passive: true });
        });
        this.querySelectorAll('[data-garment-link]').forEach(link => {
          link.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') this.previewGarment(link, 150); }, { signal });
          link.addEventListener('pointerleave', () => this.cancelGarmentPreview(), { signal });
          link.addEventListener('focus', () => this.previewGarment(link), { signal });
          link.addEventListener('blur', () => this.cancelGarmentPreview(), { signal });
        });
        this.addEventListener('click', event => {
          const control = event.target.closest('a, button');
          if (!control || !this.contains(control)) return;
          if (control.hasAttribute('data-garment-link')) {
            this.cancelGarmentPreview();
            if (!this.mobile && !this.reading && !event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
              history.replaceState({ ...history.state, bespokeGarment: { section: this.dataset.sectionId, choice: control.dataset.garmentLink } }, '');
            }
          } else if (control.hasAttribute('data-go') && !this.reading) {
            event.preventDefault(); this.go(Number(control.dataset.go), true);
          } else if (control.hasAttribute('data-next')) {
            this.go(this.index + 1, true);
          } else if (control.hasAttribute('data-previous')) {
            this.go(this.index - 1, true);
          } else if (control.hasAttribute('data-choice') && !this.reading) {
            event.preventDefault(); this.select(control.closest('[data-choice-group]'), control.dataset.choice, true);
          } else if (control.hasAttribute('data-garment-direction') && this.mobile && !this.reading) {
            const group = control.closest('[data-choice-group]');
            const tabs = Array.from(group.querySelectorAll('[data-choice]'));
            const index = tabs.findIndex(tab => tab.dataset.choice === group.dataset.selected) + Number(control.dataset.garmentDirection);
            if (tabs[index]) this.select(group, tabs[index].dataset.choice, true);
          } else if (control.hasAttribute('data-booking')) {
            this.openBooking(event, control);
          }
        }, { signal });
        document.addEventListener('wheel', event => this.onWheel(event), { signal, passive: false, capture: true });
        this.addEventListener('touchstart', event => {
          this.touchGesture = !this.reading && !this.scrolling && event.touches.length === 1 ? {
            x: event.touches[0].clientX, y: event.touches[0].clientY,
            target: event.target, native: false, captured: false
          } : null;
        }, { signal, passive: true });
        this.addEventListener('touchmove', event => {
          const gesture = this.touchGesture;
          if (!gesture || event.touches.length !== 1) { this.touchGesture = null; return; }
          const delta = gesture.y - event.touches[0].clientY;
          const horizontal = gesture.x - event.touches[0].clientX;
          if (gesture.native || Math.abs(delta) < 10 || Math.abs(horizontal) > Math.abs(delta)) return;
          if (!gesture.captured && this.canScroll(gesture.target, delta)) { gesture.native = true; return; }
          gesture.captured = true;
          event.preventDefault();
        }, { signal, passive: false });
        this.addEventListener('touchend', event => {
          const gesture = this.touchGesture;
          this.touchGesture = null;
          if (!gesture?.captured || gesture.native || !event.changedTouches.length || performance.now() < this.gestureLockedUntil) return;
          const delta = gesture.y - event.changedTouches[0].clientY;
          const horizontal = gesture.x - event.changedTouches[0].clientX;
          if (Math.abs(delta) >= 60 && Math.abs(delta) > Math.abs(horizontal) * 1.5) this.go(this.index + Math.sign(delta), true);
        }, { signal, passive: true });
        this.addEventListener('touchcancel', () => { this.touchGesture = null; }, { signal, passive: true });
        this.addEventListener('keydown', event => {
          if (this.reading || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target.closest('input, select, textarea, [contenteditable]')) return;
          const tab = event.target.closest('[data-choice]');
          const vertical = tab?.closest('[data-choice-list]')?.dataset.choiceOrientation === 'vertical';
          const choiceKeys = vertical ? ['ArrowUp', 'ArrowDown', 'Home', 'End'] : ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (tab && choiceKeys.includes(event.key)) {
            event.preventDefault();
            const group = tab.closest('[data-choice-group]');
            const tabs = Array.from(group.querySelectorAll('[data-choice]'));
            let i = tabs.indexOf(tab);
            if (event.key === 'Home') i = 0;
            else if (event.key === 'End') i = tabs.length - 1;
            else i = (i + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + tabs.length) % tabs.length;
            this.select(group, tabs[i].dataset.choice, true); tabs[i].focus(); return;
          }
          if (!this.scrolling && ['ArrowDown', 'PageDown', 'ArrowUp', 'PageUp'].includes(event.key)) {
            if (this.canScroll(event.target, ['ArrowDown', 'PageDown'].includes(event.key) ? 1 : -1)) return;
            event.preventDefault(); this.go(this.index + (['ArrowDown', 'PageDown'].includes(event.key) ? 1 : -1), true);
          }
        }, { signal });
        this.querySelector('[data-chapter-select]')?.addEventListener('change', event => this.go(Number(event.target.value), true), { signal });
        const syncViewport = () => { this.measure(); this.groups.forEach(group => this.alignGarment(group)); };
        this.mobileViewport.addEventListener('change', () => this.updateLayout(), { signal });
        window.addEventListener('resize', syncViewport, { signal });
        window.visualViewport?.addEventListener('resize', syncViewport, { signal });
        window.addEventListener('hashchange', () => this.openHash(), { signal });
        window.addEventListener('pageshow', () => { this.restoreGarment(); if (this.scrolling) this.syncScroll(); else this.syncPlayback(); }, { signal });
        this.addEventListener('touchend', () => this.syncPlayback(), { signal, passive: true });
        document.addEventListener('visibilitychange', () => { if (this.scrolling) this.syncScroll(); else this.syncPlayback(); }, { signal });
        this.reducedMotion.addEventListener('change', () => this.syncPlayback(), { signal });
        if (this.film) {
          this.film.muted = true;
          this.film.defaultMuted = true;
          this.film.playsInline = true;
          this.film.addEventListener('canplay', () => this.syncPlayback(), { signal });
          this.film.controls = false;
          for (const event of ['playing', 'pause', 'ended', 'loadeddata', 'error']) this.film.addEventListener(event, () => this.syncFilm(), { signal });
          this.syncFilm();
        }
        if (this.dataset.editor !== 'true') {
          this.setReading(false);
          this.openHash();
          this.restoreGarment();
        }
        this.observer = new ResizeObserver(syncViewport);
        const header = document.querySelector('.header--root');
        if (header) this.observer.observe(header);
        const preview = document.getElementById('PBarNextFrame');
        if (preview) this.observer.observe(preview);
        this.measure();
        if (!this.reading) {
          this.chapterObserver = new IntersectionObserver(() => this.syncScroll(), { threshold: [0, .25, .5, .75, 1] });
          this.chapters.forEach(chapter => this.chapterObserver.observe(chapter));
          this.querySelectorAll('[data-hero-booking], [data-final-booking]').forEach(link => this.chapterObserver.observe(link));
          window.addEventListener('scroll', () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.syncScroll(); });
          }, { signal, passive: true });
          this.syncScroll();
        }
        this.dataset.ready = 'true';
      }

      disconnectedCallback() {
        this.cancelGarmentPreview();
        this.controller?.abort(); this.controller = null;
        this.observer?.disconnect();
        this.chapterObserver?.disconnect();
        this.groups?.forEach(group => cancelAnimationFrame(group.swipeFrame));
        cancelAnimationFrame(this.scrollFrame);
        this.film?.pause();
        document.documentElement.classList.remove('bespoke-journey-active');
        document.documentElement.classList.remove('bespoke-journey-mobile');
        delete document.documentElement.dataset.bespokeTone;
      }

      cancelGarmentPreview() {
        clearTimeout(this.garmentPreviewTimer);
        this.garmentPreviewTimer = null;
      }

      previewGarment(link, delay = 0) {
        this.cancelGarmentPreview();
        if (this.mobile || this.reading) return;
        const preview = () => {
          this.garmentPreviewTimer = null;
          if (this.mobile || this.reading) return;
          const group = link.closest('[data-choice-group]');
          if (group && group.dataset.selected !== link.dataset.garmentLink) this.select(group, link.dataset.garmentLink, true);
        };
        if (delay) this.garmentPreviewTimer = setTimeout(preview, delay);
        else preview();
      }

      measure() {
        const header = document.querySelector('.header--root');
        const bottom = header && !this.mobile ? Math.max(0, this.scrolling ? header.getBoundingClientRect().height : header.getBoundingClientRect().bottom) : 0;
        this.style.setProperty('--bespoke-top', `${bottom}px`);
        const preview = document.getElementById('PBarNextFrame');
        const rect = preview?.getBoundingClientRect();
        // Shopify's preview toolbar can live in a transparent full-viewport iframe.
        // Reserve the toolbar itself, not that iframe's entire bounding box.
        const previewHeight = rect && rect.width > 0 && rect.top < window.innerHeight ? Math.max(0, window.innerHeight - rect.top) : 0;
        const toolbarHeight = rect && rect.height > window.innerHeight / 2 ? 64 : Math.min(previewHeight, 100);
        this.style.setProperty('--bespoke-bottom', `${toolbarHeight}px`);
        if (this.scrolling && this.dataset.ready === 'true') this.syncScroll();
      }

      updateLayout() {
        this.cancelGarmentPreview();
        const index = this.index;
        this.layoutSwitching = true;
        this.mobile = this.mobileViewport.matches;
        this.dataset.mobile = String(this.mobile);
        this.scrolling = this.dataset.layout === 'scroll' || this.mobile;
        this.touchGesture = null;
        this.wheelTotal = 0;
        this.wheelConsumed = false;
        this.setReading(this.reading);
        if (this.scrolling && !this.reading) this.chapters[index].scrollIntoView({ behavior: 'instant', block: 'start' });
        this.layoutSwitching = false;
        this.measure();
      }

      setReading(reading) {
        this.cancelGarmentPreview();
        this.reading = reading;
        this.dataset.enhanced = String(!reading);
        document.documentElement.classList.toggle('bespoke-journey-active', !reading && !this.scrolling);
        document.documentElement.classList.toggle('bespoke-journey-mobile', !reading && this.mobile);
        this.navigation.hidden = reading || this.mobile;
        if (this.returnTop) this.returnTop.hidden = reading || this.index === 0;
        this.chapters.forEach(chapter => { chapter.inert = false; chapter.removeAttribute('aria-hidden'); });
        this.groups.forEach(group => {
          const list = group.querySelector('[data-choice-list]');
          const gallery = group.querySelector('.bespoke-journey__choice-images');
          const directLinks = !this.mobile && group.querySelector('[data-garment-link]');
          if (gallery) gallery.tabIndex = !reading && this.mobile ? 0 : -1;
          if (reading || directLinks) list.removeAttribute('role'); else list.setAttribute('role', 'tablist');
          if (!reading && !directLinks && list.dataset?.choiceOrientation === 'vertical') list.setAttribute('aria-orientation', 'vertical');
          else list.removeAttribute('aria-orientation');
          group.querySelectorAll('[data-choice]').forEach(tab => {
            if (reading || directLinks) { tab.removeAttribute('role'); tab.removeAttribute('aria-selected'); tab.removeAttribute('tabindex'); }
            else tab.setAttribute('role', 'tab');
          });
          group.querySelectorAll('[data-choice-panel]').forEach(panel => {
            panel.hidden = false;
            if (reading || directLinks) { panel.removeAttribute('role'); panel.removeAttribute('tabindex'); panel.removeAttribute('aria-labelledby'); }
            else { panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0; }
          });
          group.querySelectorAll('[data-choice-image]').forEach(image => { image.hidden = false; });
          if (!reading) this.select(group, group.dataset.selected);
        });
        if (this.film) this.film.controls = false;
        if (reading) { delete document.documentElement.dataset.bespokeTone; this.film?.pause(); }
        else { if (!this.scrolling) window.scrollTo({ top: 0, behavior: 'instant' }); this.go(this.index, false, !this.scrolling); }
        this.measure();
      }

      select(group, id, animate = false, swiped = false) {
        if (!group) return;
        const directLinks = !this.mobile && group.querySelector('[data-garment-link]');
        if (animate && this.scrolling && !directLinks && !this.mobile && document.startViewTransition && !this.reducedMotion.matches) {
          const request = group.choiceRequest = (group.choiceRequest || 0) + 1;
          group.choiceTransition?.skipTransition();
          group.choiceTransition = document.startViewTransition(() => {
            if (request === group.choiceRequest) this.select(group, id, false);
          });
          group.choiceTransition.finished.catch(() => {});
          return;
        }
        group.cancelChoiceFade?.();
        const images = Array.from(group.querySelectorAll('[data-choice-image]'));
        const previousImage = images.find(image => !image.hidden);
        group.dataset.selected = id;
        group.querySelectorAll('[data-garment-link]').forEach(link => { link.dataset.active = String(link.dataset.garmentLink === id); });
        group.querySelectorAll('[data-choice]').forEach(tab => {
          const selected = tab.dataset.choice === id;
          tab.id = `${this.dataset.sectionId}-tab-${tab.dataset.choice}`;
          if (directLinks) { tab.removeAttribute('aria-selected'); tab.tabIndex = -1; }
          else { tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; }
        });
        group.querySelectorAll('[data-choice-panel]').forEach(panel => {
          panel.hidden = panel.dataset.choicePanel !== id;
          if (!directLinks) panel.setAttribute('aria-labelledby', `${this.dataset.sectionId}-tab-${panel.dataset.choicePanel}`);
        });
        images.forEach(image => { image.hidden = !this.mobile && image.dataset.choiceImage !== id; });
        const selectedImage = images.find(image => image.dataset.choiceImage === id);
        if (directLinks && animate && !this.reducedMotion.matches && previousImage && previousImage !== selectedImage && selectedImage?.animate) {
          previousImage.hidden = false;
          selectedImage.style.zIndex = '1';
          const animation = selectedImage.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
          const finish = () => {
            animation.cancel();
            previousImage.hidden = !this.mobile && previousImage.dataset.choiceImage !== group.dataset.selected;
            selectedImage.style.zIndex = '';
            group.cancelChoiceFade = null;
          };
          group.cancelChoiceFade = finish;
          animation.finished.then(() => { if (group.cancelChoiceFade === finish) finish(); }, () => {});
        }
        const tabs = Array.from(group.querySelectorAll('[data-choice]'));
        const index = tabs.findIndex(tab => tab.dataset.choice === id);
        group.querySelectorAll('[data-garment-direction]').forEach(button => {
          const next = index + Number(button.dataset.garmentDirection);
          button.disabled = next < 0 || next >= tabs.length;
        });
        if (!swiped) this.alignGarment(group, animate);
        if (this.mobile && animate) {
          const list = group.querySelector('[data-choice-list]');
          const selected = Array.from(list.querySelectorAll('[data-choice]')).find(tab => tab.dataset.choice === id);
          if (selected) {
            const bounds = selected.getBoundingClientRect();
            const rail = list.getBoundingClientRect();
            list.scrollTo({ left: list.scrollLeft + bounds.left - rail.left - (rail.width - bounds.width) / 2, behavior: this.reducedMotion.matches || swiped ? 'instant' : 'smooth' });
          }
        }
      }

      alignGarment(group, animate = false) {
        if (!this.mobile || this.reading) return;
        const gallery = group.querySelector('.bespoke-journey__choice-images');
        const image = Array.from(group.querySelectorAll('[data-choice-image]')).find(image => image.dataset.choiceImage === group.dataset.selected);
        if (!gallery || !image || !gallery.clientWidth) return;
        const left = gallery.scrollLeft + image.getBoundingClientRect().left - gallery.getBoundingClientRect().left;
        const smooth = animate && !this.reducedMotion.matches;
        group.garmentTarget = smooth && Math.abs(gallery.scrollLeft - left) > 1 ? left : null;
        gallery.scrollTo({ left, behavior: smooth ? 'smooth' : 'instant' });
      }

      restoreGarment() {
        if (this.mobile || this.reading) return;
        const saved = history.state?.bespokeGarment;
        if (!saved || saved.section !== this.dataset.sectionId) return;
        const link = Array.from(this.querySelectorAll('[data-garment-link]')).find(item => item.dataset.garmentLink === saved.choice);
        if (!link) return;
        const chapter = link.closest('[data-chapter]');
        this.go(this.chapters.indexOf(chapter), false);
        this.select(link.closest('[data-choice-group]'), saved.choice);
      }

      syncGarmentSwipe(group) {
        if (!this.mobile || this.reading) return;
        const gallery = group.querySelector('.bespoke-journey__choice-images');
        const images = Array.from(group.querySelectorAll('[data-choice-image]'));
        if (!gallery?.clientWidth || !images.length) return;
        if (group.garmentTarget != null && Math.abs(gallery.scrollLeft - group.garmentTarget) > 1) return;
        group.garmentTarget = null;
        const index = Math.max(0, Math.min(images.length - 1, Math.round(gallery.scrollLeft / gallery.clientWidth)));
        if (images[index].dataset.choiceImage !== group.dataset.selected) this.select(group, images[index].dataset.choiceImage, true, true);
      }

      canScroll(target, delta) {
        const copy = target.closest('.bespoke-journey__copy, .bespoke-journey__hero-copy');
        if (!copy || copy.closest('[data-chapter]') !== this.chapters[this.index] || copy.scrollHeight <= copy.clientHeight + 8) return false;
        return delta > 0 ? copy.scrollTop + copy.clientHeight < copy.scrollHeight - 2 : copy.scrollTop > 2;
      }

      onWheel(event) {
        if (this.reading || this.scrolling || event.ctrlKey || event.metaKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
        const target = document.elementFromPoint(event.clientX, event.clientY);
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        const now = performance.now();
        const idle = now - this.lastWheel > 100;
        this.lastWheel = now;
        const multiplier = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.clientHeight : 1;
        const delta = event.deltaY * multiplier;
        const directionChanged = this.wheelDirection && Math.sign(delta) !== this.wheelDirection;
        const renewed = Math.abs(delta) >= 24 && Math.abs(delta) > (this.lastWheelDelta || 0) * 1.8;
        this.wheelDirection = Math.sign(delta);
        this.lastWheelDelta = Math.abs(delta);
        if (now < this.gestureLockedUntil) return;
        if (idle || directionChanged || renewed) { this.wheelTotal = 0; this.wheelConsumed = false; }
        if (this.wheelConsumed) return;
        if (this.canScroll(target, delta)) {
          target.closest('.bespoke-journey__copy, .bespoke-journey__hero-copy').scrollTop += delta;
          this.wheelTotal = 0;
          return;
        }
        this.wheelTotal += delta;
        if (Math.abs(this.wheelTotal) < 40) return;
        this.wheelConsumed = true;
        this.wheelTotal = 0;
        this.go(this.index + Math.sign(delta), true);
      }

      go(index, focus, scroll = true) {
        if (index < 0 || index >= this.chapters.length) return;
        if (index !== this.index) this.cancelGarmentPreview();
        if (index !== this.index) this.gestureLockedUntil = performance.now() + (this.reducedMotion.matches ? 150 : 450);
        this.index = index;
        this.chapters.forEach((chapter, i) => {
          chapter.dataset.active = String(i === index); chapter.inert = !this.scrolling && i !== index;
          if (this.scrolling) chapter.removeAttribute('aria-hidden'); else chapter.setAttribute('aria-hidden', String(i !== index));
        });
        const chapter = this.chapters[index];
        this.dataset.tone = chapter.dataset.tone;
        document.documentElement.dataset.bespokeTone = chapter.dataset.tone;
        this.navigation.querySelectorAll('[data-go]').forEach(button => {
          if (Number(button.dataset.go) === index) button.setAttribute('aria-current', this.scrolling ? 'location' : 'step'); else button.removeAttribute('aria-current');
        });
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        const counter = this.querySelector('[data-counter]');
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === this.chapters.length - 1;
        if (this.returnTop) this.returnTop.hidden = this.reading || index === 0;
        if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(this.chapters.length).padStart(2, '0')}`;
        const contents = this.querySelector('[data-chapter-select]');
        if (contents) contents.value = String(index);
        if (this.scrolling && scroll) chapter.scrollIntoView({ behavior: this.reducedMotion.matches ? 'instant' : 'smooth', block: 'start' });
        const label = this.navigation.querySelector(`[data-go="${index}"]`).textContent.trim();
        if (focus) {
          chapter.querySelector('h1, h2').focus({ preventScroll: true });
          this.querySelector('[data-status]').textContent = label;
          const url = new URL(window.location.href); url.hash = chapter.id;
          history.replaceState(null, '', url);
        }
        this.syncPlayback();
        if (this.mobile) this.syncMobileTone();
      }

      syncMobileTone() {
        const header = document.querySelector('.header--root');
        const position = header ? header.getBoundingClientRect().height / 2 : 40;
        const dark = Array.from(this.querySelectorAll('.bespoke-journey__hero-media, .bespoke-journey__image, .bespoke-journey__choice-images')).some(media => {
          const bounds = media.getBoundingClientRect(); return bounds.top <= position && bounds.bottom > position;
        });
        document.documentElement.dataset.bespokeTone = dark ? 'dark' : 'light';
      }

      openHash() {
        if (this.reading) return;
        const id = window.location.hash.slice(1);
        const target = Array.from(this.querySelectorAll('[id]')).find(element => element.id === id);
        const chapter = target?.closest('[data-chapter]');
        if (!chapter) return;
        this.go(this.chapters.indexOf(chapter), false);
        if (target.hasAttribute('data-choice-panel')) this.select(target.closest('[data-choice-group]'), target.dataset.choicePanel);
        if (!this.scrolling) window.scrollTo({ top: 0, behavior: 'instant' });
      }

      syncScroll() {
        if (!this.scrolling || this.reading || this.layoutSwitching) return;
        const rect = this.getBoundingClientRect();
        const inView = rect.bottom > 120 && rect.top < window.innerHeight;
        this.navigation.hidden = !inView || this.mobile;
        if (!inView) { delete document.documentElement.dataset.bespokeTone; this.syncPlayback(); return; }
        const position = Math.min(window.innerHeight * .35, 280);
        let index = 0;
        this.chapters.forEach((chapter, i) => { if (chapter.getBoundingClientRect().top <= position) index = i; });
        if (index !== this.index) this.go(index, false, false);
        const sticky = this.querySelector('[data-sticky-booking]');
        if (sticky && !this.mobile) {
          const header = Number.parseFloat(this.style.getPropertyValue('--bespoke-top')) || 0;
          const bottom = this.navigation.getBoundingClientRect().top;
          const mainActionVisible = Array.from(this.querySelectorAll('[data-hero-booking], [data-final-booking]')).some(link => {
            const bounds = link.getBoundingClientRect(); return bounds.bottom > header && bounds.top < bottom;
          });
          sticky.hidden = mainActionVisible;
        }
        this.syncPlayback();
        if (this.mobile) this.syncMobileTone();
      }

      syncPlayback() {
        if (!this.film) return;
        const bounds = this.scrolling ? this.getBoundingClientRect() : null;
        const inView = !bounds || (bounds.bottom > 120 && bounds.top < window.innerHeight);
        this.film.autoplay = !this.reading && this.index === 0 && inView && !this.reducedMotion.matches && !document.hidden;
        if (this.film.autoplay) {
          if (this.film.paused) this.film.play().catch(() => this.syncFilm());
        } else this.film.pause();
        this.syncFilm();
      }

      syncFilm() {
        if (this.film.paused || this.film.ended || this.film.error) this.film.autoplay = false;
        this.film.dataset.playing = String(this.film.autoplay && !this.film.paused && !this.film.ended && this.film.readyState >= 2 && !this.film.error);
      }

      openBooking(event, link) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        const panel = document.getElementById(this.dataset.bookingPanel);
        if (!panel?.open || typeof HTMLDialogElement === 'undefined') return;
        event.preventDefault();
        panel.open(link);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridal-conversion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bridal-service')) {
    customElements.define('bridal-service', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 767px)');
        this.panels = Array.from(this.querySelectorAll('[data-bridal-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[data-bridal-choice]'));
        this.tablist = this.querySelector('[data-bridal-tabs]');
        this.stage = this.querySelector('[data-bridal-panels]');
        this.gallery = this.querySelector('[data-bridal-gallery]');
        this.galleryPhotos = Array.from(this.querySelectorAll('[data-bridal-photo]'));
        this.galleryDialog = this.querySelector('[data-bridal-gallery-dialog]');
        this.galleryMore = this.querySelector('[data-bridal-gallery-more]');
        this.galleryExtra = Array.from(this.querySelectorAll('[data-bridal-gallery-extra]'));
        this.galleryEnlarged = this.querySelector('[data-bridal-gallery-enlarged]');
        this.galleryIndex = 0;
        this.video = this.querySelector('[data-bridal-video]');
        this.videoRegion = this.querySelector('[data-bridal-film-region]');
        this.returnTop = this.querySelector('[data-bridal-return]');
        this.index = 0;
        this.filmVisible = false;
        this.tablist?.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
        });
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-bridal-choice]');
          if (choice && this.contains(choice) && !this.modified(event)) {
            event.preventDefault(); this.select(Number(choice.dataset.bridalChoice), true);
          }
          const step = event.target.closest('[data-bridal-step]');
          if (step && this.contains(step)) this.select(this.index + Number(step.dataset.bridalStep), true);
          const photo = event.target.closest('[data-bridal-photo]');
          if (photo && this.contains(photo) && this.galleryDialog?.showModal && !this.modified(event)) {
            event.preventDefault(); this.openGallery(photo);
          }
          const photoStep = event.target.closest('[data-bridal-photo-step]');
          if (photoStep && this.contains(photoStep)) this.changeGalleryPhoto(Number(photoStep.dataset.bridalPhotoStep));
          if (event.target.closest('[data-bridal-gallery-more]')) this.expandGallery();
          const link = event.target.closest('[data-bridal-cta]');
          if (link && this.contains(link) && !this.modified(event)) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'bridal_cta_click', placement: link.dataset.placement });
            window.dispatchEvent(new CustomEvent('bridal:cta-click', { detail: { placement: link.dataset.placement } }));
            this.openBooking(event, link);
          }
          const anchor = event.target.closest('.bridal-page__begin, [data-bridal-return]');
          if (anchor && this.contains(anchor) && !this.modified(event)) {
            const target = document.getElementById(anchor.hash.slice(1));
            if (target) {
              event.preventDefault();
              if (anchor === this.returnTop) window.scrollTo({ top: 0, behavior: this.motion.matches ? 'instant' : 'smooth' });
              else target.scrollIntoView({ block: 'start', behavior: this.motion.matches ? 'instant' : 'smooth' });
            }
          }
        }, { signal });
        this.tablist?.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-bridal-choice]');
          if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = Number(tab.dataset.bridalChoice);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.panels.length - 1;
          else index += event.key === 'ArrowRight' ? 1 : -1;
          this.select(index, true);
          this.tabs[this.index].focus({ preventScroll: true });
        }, { signal });
        this.stage?.addEventListener('pointerdown', event => {
          this.clearSwipe();
          if (!this.mobile.matches || !event.isPrimary || event.pointerType !== 'touch' || this.panels.length < 2 || event.target.closest('a, button, input, select, textarea')) return;
          this.swipe = { id: event.pointerId, x: event.clientX, y: event.clientY, index: this.index };
          this.stage.setPointerCapture(event.pointerId);
        }, { signal });
        this.stage?.addEventListener('pointermove', event => {
          if (!this.swipe || event.pointerId !== this.swipe.id) return;
          const x = Math.abs(event.clientX - this.swipe.x), y = Math.abs(event.clientY - this.swipe.y);
          if (y > 12 && y > x) this.clearSwipe();
        }, { signal });
        this.stage?.addEventListener('pointerup', event => {
          if (!this.swipe || event.pointerId !== this.swipe.id) return;
          const swipe = this.clearSwipe();
          const x = event.clientX - swipe.x, y = event.clientY - swipe.y;
          if (Math.abs(x) >= 40 && Math.abs(x) > Math.abs(y) * 1.35) this.select(swipe.index + (x < 0 ? 1 : -1), true);
        }, { signal });
        this.stage?.addEventListener('pointercancel', () => this.clearSwipe(), { signal });
        this.stage?.addEventListener('lostpointercapture', () => { this.swipe = null; }, { signal });
        this.galleryDialog?.addEventListener('keydown', event => {
          if (event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey) {
            const controls = Array.from(this.galleryDialog.querySelectorAll('button')).filter(button => !button.hidden && !button.disabled);
            const first = controls[0], last = controls.at(-1);
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
            return;
          }
          if (this.modified(event) || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.changeGalleryPhoto(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.galleryDialog?.addEventListener('close', () => {
          this.unlockGallery(); this.clearGallerySwipe();
          this.galleryTrigger?.focus({ preventScroll: true });
        }, { signal });
        this.galleryEnlarged?.addEventListener('pointerdown', event => {
          this.clearGallerySwipe();
          if (!event.isPrimary || event.pointerType !== 'touch' || this.galleryPhotos.length < 2) return;
          this.gallerySwipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.galleryEnlarged.setPointerCapture(event.pointerId);
        }, { signal });
        this.galleryEnlarged?.addEventListener('pointermove', event => {
          if (!this.gallerySwipe || event.pointerId !== this.gallerySwipe.id) return;
          const x = Math.abs(event.clientX - this.gallerySwipe.x), y = Math.abs(event.clientY - this.gallerySwipe.y);
          if (y > 12 && y > x) this.clearGallerySwipe();
        }, { signal });
        this.galleryEnlarged?.addEventListener('pointerup', event => {
          if (!this.gallerySwipe || event.pointerId !== this.gallerySwipe.id) return;
          const swipe = this.clearGallerySwipe();
          const x = event.clientX - swipe.x, y = event.clientY - swipe.y;
          if (Math.abs(x) >= 40 && Math.abs(x) > Math.abs(y) * 1.35) this.changeGalleryPhoto(x < 0 ? 1 : -1);
        }, { signal });
        this.galleryEnlarged?.addEventListener('pointercancel', () => this.clearGallerySwipe(), { signal });
        this.galleryEnlarged?.addEventListener('lostpointercapture', () => { this.gallerySwipe = null; }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index !== -1) this.select(index, true);
        }, { signal });
        if (this.video) {
          this.video.muted = true; this.video.defaultMuted = true; this.video.playsInline = true; this.video.controls = false;
          this.filmObserver = new IntersectionObserver(entries => {
            this.filmVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35; this.syncPlayback();
          }, { threshold: .35 });
          this.filmObserver.observe(this.videoRegion);
          const syncFilmVisibility = () => {
            if (this.filmFrame) return;
            this.filmFrame = requestAnimationFrame(() => { this.filmFrame = null; this.syncPlayback(); });
          };
          window.addEventListener('scroll', syncFilmVisibility, { signal, passive: true });
          window.addEventListener('resize', syncFilmVisibility, { signal });
          for (const event of ['playing', 'pause', 'ended', 'loadeddata']) this.video.addEventListener(event, () => this.syncFilm(), { signal });
          this.video.addEventListener('canplay', () => this.syncPlayback(), { signal });
          this.addEventListener('touchend', () => this.syncPlayback(), { signal, passive: true });
          this.video.addEventListener('error', () => {
            if (this.video.dataset.format === 'm3u8' && this.video.dataset.fallback !== 'true') {
              this.video.dataset.fallback = 'true'; delete this.video.dataset.loaded; this.syncPlayback();
            }
            this.syncFilm();
          }, { signal });
          document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
          this.motion.addEventListener('change', () => this.syncPlayback(), { signal });
          window.addEventListener('pageshow', () => this.syncPlayback(), { signal });
          this.syncFilm();
        }
        this.heroObserver = new IntersectionObserver(entries => { this.returnTop.hidden = entries[0].isIntersecting; }, { threshold: 0 });
        this.heroObserver.observe(this.querySelector('[data-bridal-hero]'));
        this.previewBar = document.querySelector('#PBarNextFrame');
        this.resizeObserver = new ResizeObserver(() => this.syncPreview());
        if (this.previewBar) this.resizeObserver.observe(this.previewBar);
        window.addEventListener('resize', () => this.syncPreview(), { signal });
        this.select(0, false);
        this.dataset.enhanced = 'true'; this.dataset.ready = 'true';
        this.querySelectorAll('.bridal-page__swipe-controls').forEach(control => { control.hidden = false; });
        this.galleryExtra.forEach(figure => { figure.hidden = true; });
        if (this.galleryMore) this.galleryMore.hidden = false;
        this.syncPreview();
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller = null; this.clearSwipe();
        this.filmObserver?.disconnect(); this.heroObserver?.disconnect(); this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.filmFrame); this.filmFrame = null;
        this.video?.pause();
        this.clearGallerySwipe();
        if (this.galleryDialog?.open) { this.galleryDialog.close(); this.unlockGallery(); }
      }
      modified(event) { return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0; }
      select(index, reveal) {
        if (!this.panels.length) return;
        this.index = (index + this.panels.length) % this.panels.length;
        const template = this.panels[this.index].querySelector('template[data-bridal-media]');
        if (template) {
          template.replaceWith(template.content);
          this.panels[this.index].querySelector('noscript')?.remove();
        }
        this.panels.forEach((panel, i) => {
          const active = i === this.index;
          panel.dataset.active = String(active); panel.inert = !active; panel.setAttribute('aria-hidden', String(!active));
          this.tabs[i].dataset.active = String(active); this.tabs[i].setAttribute('aria-selected', String(active)); this.tabs[i].tabIndex = active ? 0 : -1;
        });
        if (reveal) {
          this.panels[this.index].querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
          const tab = this.tabs[this.index];
          if (this.tablist.scrollWidth > this.tablist.clientWidth) this.tablist.scrollTo({ left: Math.max(0, tab.offsetLeft - (this.tablist.clientWidth - tab.offsetWidth) / 2), behavior: this.motion.matches ? 'instant' : 'smooth' });
        }
      }
      clearSwipe() {
        const swipe = this.swipe; this.swipe = null;
        if (swipe && this.stage?.hasPointerCapture(swipe.id)) this.stage.releasePointerCapture(swipe.id);
        return swipe;
      }
      expandGallery() {
        const first = this.galleryExtra[0]?.querySelector('a');
        this.galleryExtra.forEach(figure => { figure.hidden = false; });
        this.galleryMore?.setAttribute('aria-expanded', 'true');
        first?.focus({ preventScroll: true });
        if (this.galleryMore) this.galleryMore.hidden = true;
      }
      openGallery(photo) {
        this.galleryTrigger = photo;
        this.galleryIndex = this.galleryPhotos.indexOf(photo);
        this.drawGalleryPhoto();
        if (!this.galleryDialog.open) {
          this.galleryOverflow = document.documentElement.style.overflow;
          this.galleryDialog.showModal(); document.documentElement.style.overflow = 'hidden';
        }
      }
      drawGalleryPhoto() {
        const photo = this.galleryPhotos[this.galleryIndex];
        if (!photo) return;
        const source = photo.querySelector('img');
        const preview = source.cloneNode(false);
        preview.loading = 'eager'; preview.removeAttribute('srcset'); preview.removeAttribute('sizes'); preview.src = source.currentSrc || source.src;
        this.galleryEnlarged.replaceChildren(preview);
        const request = this.galleryRequest = (this.galleryRequest || 0) + 1;
        const image = document.createElement('img');
        image.alt = source.alt; image.decoding = 'async';
        image.addEventListener('load', () => {
          if (this.galleryDialog.open && this.galleryRequest === request) this.galleryEnlarged.replaceChildren(image);
        }, { once: true });
        image.src = photo.href;
        if (image.complete && image.naturalWidth && this.galleryRequest === request) this.galleryEnlarged.replaceChildren(image);
        const caption = this.querySelector('[data-bridal-gallery-caption]');
        caption.textContent = photo.dataset.caption; caption.hidden = !photo.dataset.caption;
        this.querySelector('[data-bridal-gallery-status]').textContent = this.galleryDialog.dataset.status.replace('__CURRENT__', this.galleryIndex + 1).replace('__TOTAL__', this.galleryPhotos.length);
        this.querySelectorAll('[data-bridal-photo-step]').forEach(button => { button.hidden = this.galleryPhotos.length < 2; });
      }
      changeGalleryPhoto(direction) {
        if (!this.galleryPhotos.length) return;
        this.galleryIndex = (this.galleryIndex + direction + this.galleryPhotos.length) % this.galleryPhotos.length;
        this.drawGalleryPhoto();
      }
      clearGallerySwipe() {
        const swipe = this.gallerySwipe; this.gallerySwipe = null;
        if (swipe && this.galleryEnlarged?.hasPointerCapture(swipe.id)) this.galleryEnlarged.releasePointerCapture(swipe.id);
        return swipe;
      }
      unlockGallery() {
        this.galleryRequest = (this.galleryRequest || 0) + 1;
        if (this.galleryOverflow !== undefined) { document.documentElement.style.overflow = this.galleryOverflow; delete this.galleryOverflow; }
      }
      loadFilm() {
        if (this.video.dataset.loaded === 'true') return true;
        const sources = Array.from(this.video.querySelectorAll('source[data-src]'));
        const hls = sources.find(source => source.dataset.format === 'm3u8' && this.video.canPlayType(source.type));
        const mp4 = sources.filter(source => source.dataset.format === 'mp4').sort((a, b) => Number(a.dataset.height) - Number(b.dataset.height));
        const suitable = mp4.filter(source => Number(source.dataset.height) <= (this.mobile.matches ? 720 : 1080));
        const source = (this.video.dataset.fallback !== 'true' && hls) || suitable.at(-1) || mp4[0] || sources.find(source => this.video.canPlayType(source.type));
        if (!source) return false;
        this.video.dataset.loaded = 'true'; this.video.dataset.format = source.dataset.format;
        this.video.muted = true; this.video.defaultMuted = true; this.video.src = source.dataset.src; this.video.load();
        return true;
      }
      syncPlayback() {
        if (!this.video) return;
        const bounds = this.videoRegion.getBoundingClientRect();
        const visibleHeight = Math.max(0, Math.min(bounds.bottom, window.innerHeight) - Math.max(bounds.top, 0));
        this.filmVisible = bounds.width > 0 && bounds.height > 0 && visibleHeight >= Math.min(bounds.height, window.innerHeight) * .35;
        this.video.autoplay = this.filmVisible && !document.hidden && !this.motion.matches;
        if (this.video.autoplay) {
          if (this.video.paused && this.loadFilm()) this.video.play().catch(() => this.syncFilm());
        } else this.video.pause();
      }
      syncFilm() {
        if (this.video.paused || this.video.ended || this.video.error) this.video.autoplay = false;
        this.video.dataset.playing = String(this.video.autoplay && !this.video.paused && !this.video.ended && this.video.readyState >= 2 && !this.video.error);
      }
      syncPreview() {
        const bounds = this.previewBar?.getBoundingClientRect();
        const height = bounds && bounds.width > 0 && bounds.top < innerHeight ? Math.max(0, innerHeight - bounds.top) : 0;
        const toolbar = bounds && bounds.height > innerHeight / 2 ? 64 : Math.min(height, 100);
        this.style.setProperty('--bridal-preview-bottom', toolbar + 'px');
      }
      async openBooking(event, link) {
        event.preventDefault();
        if (link.getAttribute('aria-busy') === 'true') return;
        link.setAttribute('aria-busy', 'true');
        try {
          if (!document.getElementById('calendly-widget-css')) {
            const css = document.createElement('link'); css.id = 'calendly-widget-css'; css.rel = 'stylesheet'; css.href = 'https://assets.calendly.com/assets/external/widget.css'; document.head.appendChild(css);
          }
          if (!window.Calendly?.initPopupWidget) {
            await new Promise((resolve, reject) => {
              let script = document.getElementById('calendly-widget-js');
              const timeout = setTimeout(() => reject(new Error('Booking unavailable')), 8000);
              const done = () => { clearTimeout(timeout); resolve(); };
              const fail = () => { clearTimeout(timeout); reject(new Error('Booking unavailable')); };
              if (!script) {
                script = document.createElement('script'); script.id = 'calendly-widget-js'; script.async = true; script.src = 'https://assets.calendly.com/assets/external/widget.js';
                script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true }); document.head.appendChild(script);
              } else { script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true }); }
            });
          }
          if (!window.Calendly?.initPopupWidget) throw new Error('Booking unavailable');
          window.Calendly.initPopupWidget({ url: link.href });
        } catch (_) { window.location.assign(link.href); }
        finally { link.removeAttribute('aria-busy'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club-service"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('club-service')) customElements.define('club-service', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController(); const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog'); this.photos = Array.from(this.querySelectorAll('[data-club-photo]'));
      const show = () => { const source = this.photos[this.index]; const image = document.createElement('img'); image.src = source.href; image.alt = source.querySelector('img').alt; this.querySelector('[data-club-enlarged]').replaceChildren(image); };
      const change = direction => { this.index = (this.index + direction + this.photos.length) % this.photos.length; show(); };
      this.addEventListener('click', event => { const photo = event.target.closest('[data-club-photo]'); if (photo && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey && this.dialog.showModal) { event.preventDefault(); this.trigger = photo; this.index = this.photos.indexOf(photo); show(); this.dialog.showModal(); } const direction = event.target.closest('[data-club-direction]'); if (direction) change(Number(direction.dataset.clubDirection)); if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.dialog.addEventListener('keydown', event => { if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.ctrlKey || event.altKey || event.metaKey) return; event.preventDefault(); change(event.key === 'ArrowRight' ? 1 : -1); }, { signal });
      this.dialog.addEventListener('close', () => this.trigger?.focus({ preventScroll: true }), { signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amanjeda-contact')) {
    customElements.define('amanjeda-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-contact-booking]');
          if (link && this.contains(link) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) this.openBooking(event, link);
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
      async openBooking(event, link) {
        event.preventDefault();
        if (link.getAttribute('aria-busy') === 'true') return;
        link.setAttribute('aria-busy', 'true');
        try {
          if (!document.getElementById('calendly-widget-css')) {
            const css = document.createElement('link');
            css.id = 'calendly-widget-css'; css.rel = 'stylesheet';
            css.href = 'https://assets.calendly.com/assets/external/widget.css'; document.head.appendChild(css);
          }
          if (!window.Calendly?.initPopupWidget) {
            await new Promise((resolve, reject) => {
              let script = document.getElementById('calendly-widget-js');
              const timeout = setTimeout(() => reject(new Error('Booking unavailable')), 8000);
              const done = () => { clearTimeout(timeout); resolve(); };
              const fail = () => { clearTimeout(timeout); reject(new Error('Booking unavailable')); };
              if (!script) {
                script = document.createElement('script'); script.id = 'calendly-widget-js'; script.async = true;
                script.src = 'https://assets.calendly.com/assets/external/widget.js';
                script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true }); document.head.appendChild(script);
              } else {
                script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true });
              }
            });
          }
          if (!window.Calendly?.initPopupWidget) throw new Error('Booking unavailable');
          window.Calendly.initPopupWidget({ url: link.href });
        } catch (_) { window.location.assign(link.href); }
        finally { link.removeAttribute('aria-busy'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('event-story')) {
    customElements.define('event-story', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.photos = Array.from(this.querySelectorAll('[data-event-photo]'));
        this.dialog = this.querySelector('dialog');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.addEventListener('click', event => {
          const photo = event.target.closest('[data-event-photo]');
          if (photo && this.contains(photo) && this.dialog.showModal && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault(); this.trigger = photo; this.index = this.photos.indexOf(photo); this.drawPhoto(); this.dialog.showModal();
          }
          const film = event.target.closest('[data-event-play]');
          if (film && this.contains(film) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) this.playFilm(event, film);
          if (event.target.closest('[data-event-previous]')) this.changePhoto(-1);
          if (event.target.closest('[data-event-next]')) this.changePhoto(1);
          if (event.target === this.dialog) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.changePhoto(event.key === 'ArrowLeft' ? -1 : 1);
        }, { signal });
        this.dialog.addEventListener('close', () => { if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true }); }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
      drawPhoto() {
        const photo = this.photos[this.index];
        if (!photo) return;
        const image = document.createElement('img'); image.src = photo.href; image.alt = photo.dataset.imageAlt;
        this.querySelector('[data-event-enlarged]').replaceChildren(image);
        this.querySelector('[data-event-caption]').textContent = photo.dataset.caption;
        this.querySelector('[data-event-status]').textContent = this.dataset.photoStatus.replace('__CURRENT__', this.index + 1).replace('__TOTAL__', this.photos.length);
        this.querySelector('[data-event-previous]').hidden = this.photos.length < 2;
        this.querySelector('[data-event-next]').hidden = this.photos.length < 2;
      }
      changePhoto(direction) {
        this.index = (this.index + direction + this.photos.length) % this.photos.length;
        if (document.startViewTransition && !this.motion.matches) document.startViewTransition(() => this.drawPhoto());
        else this.drawPhoto();
      }
      playFilm(event, link) {
        const player = link.closest('[data-event-player]');
        const type = player.dataset.filmType;
        if (!['youtube', 'vimeo'].includes(type)) return;
        event.preventDefault();
        const frame = document.createElement('iframe');
        const id = encodeURIComponent(player.dataset.filmId);
        const start = Number(player.dataset.filmStart) || 0;
        frame.src = type === 'youtube' ? `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&start=${start}` : `https://player.vimeo.com/video/${id}?autoplay=1#t=${start}s`;
        frame.title = player.dataset.filmTitle; frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; frame.allowFullscreen = true;
        player.replaceChildren(frame); frame.focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-loop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amanjeda-events')) {
    customElements.define('amanjeda-events', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.cycles = this.querySelector('[data-events-cycles]');
        this.source = this.cycles?.querySelector('[data-events-cycle]');
        this.end = this.querySelector('[data-events-end]');
        this.more = this.querySelector('[data-events-more]');
        this.status = this.querySelector('[data-events-status]');
        if (!this.source?.children.length || this.dataset.loopEnabled !== 'true' || window.Shopify?.designMode) return;
        this.template = this.source.cloneNode(true);
        this.sequence = 0;
        this.cycles.dataset.cycleCount = '1';
        this.more.hidden = false;
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const more = event.target.closest('[data-events-more]');
          if (more && this.contains(more)) this.appendCycle(true);
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) this.appendCycle();
          }, { rootMargin: '1200px 0px', threshold: 0 });
          this.observer.observe(this.end);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      appendCycle(manual = false) {
        if (this.loading || !this.isConnected) return;
        this.loading = true;
        const cycle = this.template.cloneNode(true);
        cycle.dataset.repeat = String(++this.sequence);
        cycle.removeAttribute('id');
        cycle.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        cycle.querySelectorAll('[data-shopify-editor-block]').forEach(element => element.removeAttribute('data-shopify-editor-block'));
        this.cycles.appendChild(cycle);
        this.trimCycles();
        this.cycles.dataset.cycleCount = String(this.cycles.children.length);
        if (this.status) this.status.textContent = this.status.dataset.repeatLabel;
        if (manual) cycle.querySelector('a')?.focus({ preventScroll: true });
        this.frame = requestAnimationFrame(() => {
          this.loading = false;
          this.frame = null;
          this.observer?.unobserve(this.end);
          this.observer?.observe(this.end);
        });
      }

      trimCycles() {
        while (this.cycles.children.length > 3) {
          const first = this.cycles.firstElementChild;
          if (first.getBoundingClientRect().bottom >= -window.innerHeight || first.contains(document.activeElement)) break;
          const marker = this.cycles.children[1];
          const before = marker.getBoundingClientRect().top;
          first.remove();
          const delta = marker.getBoundingClientRect().top - before;
          window.scrollBy(0, delta);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabric-book"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fabric-book')) {
    customElements.define('fabric-book', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController(); const signal = this.controller.signal;
        const initialize = () => customElements.whenDefined('editorial-carousel').then(() => { if (!signal.aborted) this.initialize(signal); });
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true, signal }); else initialize();
      }
      initialize(signal) {
        this.cards = Array.from(this.closest('#main_content').querySelectorAll('[data-fabric-source] [data-fabric-swatch]'), card => card.cloneNode(true));
        if (!this.cards.length) { this.dataset.enhanced = 'false'; this.querySelector('.fabric-book__begin').href = `#fabric-book-introduction-${this.dataset.sectionId}`; return; }
        this.carousel = this.querySelector('editorial-carousel'); this.material = ''; this.selectedCode = '';
        this.buttons = Array.from(this.querySelectorAll('[data-book-material]'));
        this.collectionButtons = Array.from(this.querySelectorAll('[data-book-collection]'));
        this.collection = this.collectionButtons[0]?.dataset.bookCollection || '';
        this.prepareCards();
        this.buttons.forEach(button => { button.hidden = !!button.dataset.bookMaterial && !this.cards.some(card => card.dataset.materials.split(',').includes(button.dataset.bookMaterial)); });
        if (this.hasAttribute('data-refined-browser')) this.refineBrowser();
        this.zoom = this.querySelector('dialog');
        this.addEventListener('click', event => {
          const filter = event.target.closest('[data-book-material]');
          if (filter) { this.material = filter.dataset.bookMaterial; this.filter(); }
          const collection = event.target.closest('[data-book-collection]');
          if (collection) { this.collection = collection.dataset.bookCollection; this.filter(); }
          const swatch = event.target.closest('[data-select-swatch]');
          if (swatch && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) { event.preventDefault(); this.select(swatch.closest('[data-fabric-swatch]').dataset.code, true); }
          if (event.target.closest('.fabric-book__begin') && this.dataset.ready === 'true' && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) { event.preventDefault(); this.querySelector('[data-book-library]').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' }); }
          if (event.target.closest('[data-book-enlarge]')) {
            const image = this.querySelector('[data-book-preview-image] img').cloneNode(true); image.loading = 'eager'; image.sizes = '95vw';
            this.querySelector('[data-book-zoom-title]').textContent = this.querySelector('[data-book-composition]').textContent;
            this.querySelector('[data-book-zoom-image]').replaceChildren(image);
            this.previousOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; this.zoom.showModal();
            if (this.dataset.zoomModule) import(this.dataset.zoomModule).then(({ attachZoom }) => { if (!signal.aborted && this.zoom.open) { this.zoomCleanup?.(); this.zoomCleanup = attachZoom(this.zoom, signal); } }).catch(() => {});
          }
          if (event.target.closest('[data-book-close-zoom]')) this.zoom.close();
        }, { signal });
        this.addEventListener('keydown', event => {
          const swatch = event.target.closest('[data-select-swatch]');
          if (swatch && event.key === ' ') { event.preventDefault(); this.select(swatch.closest('[data-fabric-swatch]').dataset.code, true); }
        }, { signal });
        this.zoom.addEventListener('close', () => { this.zoomCleanup?.(); this.zoomCleanup = null; document.documentElement.style.overflow = this.previousOverflow ?? ''; this.querySelector('[data-book-enlarge]').focus({ preventScroll: true }); }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.getAttribute('data-shopify-editor-block')?.includes(event.detail.blockId));
          if (card) { this.material = ''; this.collection = this.collectionButtons.length ? card.dataset.collection : ''; this.filter(); this.select(card.dataset.code, false); }
        }, { signal });
        document.addEventListener('shopify:section:load', event => {
          if (!event.target.querySelector('[data-fabric-source]')) return;
          this.cards = Array.from(this.closest('#main_content').querySelectorAll('[data-fabric-source] [data-fabric-swatch]'), card => card.cloneNode(true));
          this.prepareCards();
          this.buttons.forEach(button => { button.hidden = !!button.dataset.bookMaterial && !this.cards.some(card => card.dataset.materials.split(',').includes(button.dataset.bookMaterial)); });
          if (this.hasAttribute('data-refined-browser')) this.refineBrowser();
          if (this.material && !this.cards.some(card => card.dataset.materials.split(',').includes(this.material))) this.material = '';
          this.filter();
        }, { signal });
        this.querySelector('[data-book-library]').hidden = false;
        this.filter(); this.dataset.ready = 'true'; this.dataset.enhanced = 'true';
        if (this.hasAttribute('data-refined-browser')) {
          this.querySelector('.fabric-book__begin').href = `#fabric-book-library-${this.dataset.sectionId}`;
          let width = 0;
          this.refinedResize = new ResizeObserver(entries => {
            const next = entries[0].contentRect.width;
            if (Math.abs(width - next) < 1) return;
            width = next;
            cancelAnimationFrame(this.refinedFrame);
            this.refinedFrame = requestAnimationFrame(() => {
              const track = this.carousel.querySelector('[data-loop-track]');
              const card = Array.from(track.children).find(item => !item.hasAttribute('data-loop-clone') && item.dataset.code === this.selectedCode);
              if (card) track.scrollTo({ left: track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left - 4, behavior: 'instant' });
            });
          });
          this.refinedResize.observe(this.carousel);
        }
      }
      refineBrowser() {
        let useful = 0;
        this.buttons.forEach(button => {
          const material = button.dataset.bookMaterial;
          if (!material) return;
          const count = this.cards.filter(card => card.dataset.materials.split(',').includes(material)).length;
          button.hidden = count === 0 || count === this.cards.length;
          if (!button.hidden) useful++;
        });
        const filters = this.querySelector('.fabric-book__filters:not(.fabric-book__collections)');
        if (filters) filters.hidden = useful === 0;
        if (this.buttons.some(button => button.hidden && button.dataset.bookMaterial === this.material)) this.material = '';
      }
      disconnectedCallback() { if (this.zoom?.open) this.zoom.close(); this.controller?.abort(); this.controller = null; this.refinedResize?.disconnect(); cancelAnimationFrame(this.refinedFrame); }
      prepareCards() {
        this.cards.forEach((card, index) => {
          const link = card.querySelector('[data-select-swatch]');
          link.setAttribute('role', 'button');
          link.setAttribute('aria-controls', this.querySelector('[data-book-composition-heading]').id);
          link.setAttribute('aria-label', this.dataset.selectTemplate.replace('__NUMBER__', index + 1).replace('__COMPOSITION__', card.dataset.composition));
        });
      }
      filter() {
        this.filtered = this.cards.filter(card => (!this.collection || card.dataset.collection === this.collection) && (!this.material || card.dataset.materials.split(',').includes(this.material)));
        this.carousel.setItems(this.filtered);
        this.collectionButtons?.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bookCollection === this.collection)));
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bookMaterial === this.material)));
        this.querySelector('[data-book-count]').textContent = this.dataset.countTemplate.replace('__COUNT__', this.filtered.length);
        const selected = this.filtered.find(card => card.dataset.code === this.selectedCode) || this.filtered[0];
        if (selected) this.select(selected.dataset.code, false);
      }
      select(code, announce) {
        const card = this.cards.find(item => item.dataset.code === code); if (!card) return;
        this.selectedCode = code;
        const alt = this.dataset.previewTemplate.replace('__COMPOSITION__', card.dataset.composition);
        const image = document.createElement('img');
        if (card.dataset.imageSrcset) { image.sizes = '(min-width: 768px) 460px, calc(100vw - 88px)'; image.srcset = card.dataset.imageSrcset; }
        image.src = card.dataset.imageUrl; image.alt = alt; image.width = Number(card.dataset.imageWidth); image.height = Number(card.dataset.imageHeight); image.decoding = 'async';
        this.querySelector('[data-book-preview-image]').replaceChildren(image);
        this.querySelector('[data-book-composition]').textContent = card.dataset.composition;
        if (this.hasAttribute('data-refined-browser')) this.querySelector('[data-book-count]').textContent = `${this.filtered.findIndex(item => item.dataset.code === code) + 1} / ${this.filtered.length}`;
        this.cards.forEach(item => { const link = item.querySelector('[data-select-swatch]'); link.dataset.selected = String(item.dataset.code === code); link.setAttribute('aria-pressed', String(item.dataset.code === code)); });
        this.carousel.querySelectorAll('[data-fabric-swatch]').forEach(item => { const link = item.querySelector('[data-select-swatch]'); link.dataset.selected = String(item.dataset.code === code); link.setAttribute('aria-pressed', String(item.dataset.code === code)); });
        if (announce) this.querySelector('[data-book-selection-status]').textContent = this.hasAttribute('data-refined-browser') ? card.querySelector('[data-select-swatch]').getAttribute('aria-label') : alt;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabric-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fabric-explorer')) {
    customElements.define('fabric-explorer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.grid = this.querySelector('[data-results]');
        this.hero = this.querySelector('.fabric-explorer__hero');
        this.library = this.querySelector('.fabric-explorer__library');
        this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
        this.selects = Array.from(this.querySelectorAll('[data-filter-select]'));
        this.selected = { garment: new Set(), fabric: new Set() };
        this.readCards();
        import(this.dataset.browsingUrl).then(module => {
          if (signal.aborted) return;
          this.browsing = module;
          this.restorePosition();
        }).catch(() => {});
        this.addEventListener('click', event => {
          const bookLink = event.target.closest('[data-fabric-card] a');
          if (bookLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
            this.departureCard = bookLink.closest('[data-fabric-card]');
            this.rememberPosition(this.departureCard);
          }
          const filter = event.target.closest('[data-filter]');
          if (filter && !filter.disabled) {
            const value = filter.dataset.value;
            this.selected[filter.dataset.filter] = new Set(value ? [value] : []);
            this.applyFilters(true);
          }
          if (event.target.closest('[data-reset]')) {
            Object.values(this.selected).forEach(selected => selected.clear());
            this.applyFilters(true);
          }
          if (event.target.closest('.fabric-explorer__begin')) {
            event.preventDefault();
            this.library.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
            this.library.querySelector('h2').focus({ preventScroll: true });
          }
        }, { signal });
        this.addEventListener('change', event => {
          const select = event.target.closest('[data-filter-select]');
          if (!select) return;
          this.selected[select.dataset.filterSelect] = new Set(select.value ? [select.value] : []);
          this.applyFilters(true);
        }, { signal });
        window.addEventListener('popstate', () => this.readFilters(), { signal });
        window.addEventListener('pagehide', () => { if (!this.departureCard) this.rememberPosition(); this.positionRestored = false; this.departureCard = null; }, { signal });
        window.addEventListener('pageshow', event => { if (event.persisted) this.restorePosition(); }, { signal });
        window.addEventListener('resize', () => this.syncHeader(), { signal });
        window.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.syncHeader(); });
        }, { signal, passive: true });
        this.header = document.querySelector('.header--root');
        this.observer = new ResizeObserver(() => this.syncHeader());
        if (this.header) this.observer.observe(this.header);
        this.previewBar = document.querySelector('#PBarNextFrame');
        if (this.previewBar) this.observer.observe(this.previewBar);
        this.syncHeader();
        if (this.grid.dataset.nextPage) this.loadRemaining();
        else this.enableFilters();
      }

      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        delete document.documentElement.dataset.fabricHero;
      }

      syncHeader() {
        const height = this.header?.getBoundingClientRect().height || 106;
        this.style.setProperty('--fabric-top', `${height}px`);
        this.previewBar = document.querySelector('#PBarNextFrame');
        const previewRect = this.previewBar?.getBoundingClientRect();
        const previewHeight = previewRect ? Math.max(0, Math.min(innerHeight, previewRect.bottom) - Math.max(0, previewRect.top)) : 0;
        this.style.setProperty('--fabric-bottom', `${previewHeight > innerHeight / 2 ? 64 : Math.min(previewHeight, 100)}px`);
        document.documentElement.dataset.fabricHero = String(this.hero.getBoundingClientRect().bottom > height + 80);
      }

      readCards() {
        const ordered = Array.from(this.grid.querySelectorAll('[data-fabric-card]')).sort((a, b) => Number(a.dataset.priority || 0) - Number(b.dataset.priority || 0));
        ordered.forEach(element => this.grid.append(element));
        this.cards = ordered.map(element => ({
          element,
          garment: element.dataset.garment.split(',').filter(Boolean),
          fabric: element.dataset.fabric.split(',').filter(Boolean)
        }));
      }

      readFilters() {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const legacyTags = (url.pathname.split('/tagged/')[1] || '').split('+').map(value => decodeURIComponent(value).toLowerCase());
        const garmentTags = {
          suits: ['suits-fabrics', 'bespoke-suits'],
          blazers: ['blazer-fabrics', 'bespoke-blazers', 'atelier-blazers'],
          shirts: ['shirts-fabrics', 'bespoke-shirts'],
          trousers: ['trousers-fabrics', 'bespoke-trousers', 'atelier-trousers'],
          dresses: ['dress-fabrics', 'atelier-dresses-skirts', 'atelier-eveningwear'],
          outerwear: ['overcoats-fabrics', 'light-outerwear-fabrics', 'winter-outerwear-fabrics', 'jackets-fabrics', 'bespoke-winter-outerwear', 'bespoke-light-outerwear'],
          casualwear: ['t-shirts-polos-fabrics', 'bespoke-casual-luxury', 'atelier-casualwear']
        };
        for (const group of ['garment', 'fabric']) {
          const allowed = new Set(this.buttons.filter(button => button.dataset.filter === group).map(button => button.dataset.value));
          const values = params.has(group) ? params.get(group).split(',') : [...allowed].filter(value => legacyTags.some(tag => group === 'fabric' ? tag === value : garmentTags[value]?.includes(tag)));
          this.selected[group] = new Set(values.filter(value => value && allowed.has(value)).slice(0, 1));
        }
        this.applyFilters(false);
      }

      enableFilters() {
        this.readCards();
        this.querySelector('[data-filter-controls]').hidden = false;
        this.querySelector('[data-pagination]')?.setAttribute('hidden', '');
        this.readFilters();
        this.dataset.ready = 'true';
        this.restorePosition();
      }

      viewUrl() {
        const url = new URL(this.dataset.libraryUrl, location.origin);
        for (const group of ['garment', 'fabric']) if (this.selected[group].size) url.searchParams.set(group, [...this.selected[group]][0]);
        return url.pathname + url.search;
      }

      rememberPosition(card) {
        if (!this.browsing || this.dataset.ready !== 'true') return;
        card ||= this.cards.find(item => !item.element.hidden && item.element.getBoundingClientRect().bottom > 0)?.element;
        const view = { url: this.viewUrl(), articleId: card?.dataset.articleId || '', offset: card?.getBoundingClientRect().top || 0, y: window.scrollY, at: Date.now(), returning: false };
        const state = { ...history.state, amanjedaFabricLibrary: view };
        try { history.replaceState(state, ''); } catch {}
        try { this.browsing.writeLibraryView(sessionStorage, view, this.dataset.libraryUrl, location.origin); } catch {}
      }

      restorePosition() {
        if (!this.browsing || this.dataset.ready !== 'true' || this.positionRestored) return;
        let view = history.state?.amanjedaFabricLibrary;
        if (!this.browsing.validLibraryView(view, this.dataset.libraryUrl, location.origin)) {
          try { view = this.browsing.readLibraryView(sessionStorage, this.dataset.libraryUrl, location.origin); } catch { view = null; }
          if (!view?.returning) return;
        }
        if (view.url !== this.viewUrl()) return;
        this.positionRestored = true;
        try { this.browsing.writeLibraryView(sessionStorage, { ...view, returning: false }, this.dataset.libraryUrl, location.origin); } catch {}
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (this.controller?.signal.aborted) return;
          const card = this.cards.find(item => item.element.dataset.articleId === view.articleId && !item.element.hidden)?.element;
          const maximum = Math.max(0, document.documentElement.scrollHeight - innerHeight);
          window.scrollTo({ top: this.browsing.restoreTop(view, card?.getBoundingClientRect().top, window.scrollY, maximum), behavior: 'instant' });
          card?.querySelector('a').focus({ preventScroll: true });
        }));
      }

      applyFilters(updateUrl) {
        const availableMaterials = new Set(this.cards.filter(card => !this.selected.garment.size || card.garment.some(value => this.selected.garment.has(value))).flatMap(card => card.fabric));
        if ([...this.selected.fabric].some(value => !availableMaterials.has(value))) {
          this.selected.fabric.clear();
          updateUrl = true;
        }
        let count = 0;
        for (const card of this.cards) {
          const visible = ['garment', 'fabric'].every(group => !this.selected[group].size || card[group].some(value => this.selected[group].has(value)));
          card.element.hidden = !visible;
          if (visible) count++;
        }
        for (const button of this.buttons) {
          button.disabled = button.dataset.filter === 'fabric' && Boolean(button.dataset.value) && !availableMaterials.has(button.dataset.value);
          const selected = this.selected[button.dataset.filter];
          button.setAttribute('aria-pressed', String(button.dataset.value ? selected.has(button.dataset.value) : !selected.size));
        }
        for (const select of this.selects) {
          select.value = [...this.selected[select.dataset.filterSelect]][0] || '';
          if (select.dataset.filterSelect === 'fabric') {
            for (const option of select.options) option.disabled = Boolean(option.value) && !availableMaterials.has(option.value);
          }
        }
        this.querySelector('[data-result-count]').textContent = this.dataset.countTemplate.replace('__COUNT__', count);
        this.querySelector('[data-empty]').hidden = count !== 0;
        this.querySelector('.fabric-explorer__results-bar [data-reset]').hidden = !Object.values(this.selected).some(selected => selected.size);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.pathname = this.dataset.libraryUrl;
          for (const group of ['garment', 'fabric']) {
            if (this.selected[group].size) url.searchParams.set(group, [...this.selected[group]].sort().join(','));
            else url.searchParams.delete(group);
          }
          url.searchParams.delete('page');
          history.replaceState({ ...history.state, amanjedaFabricLibrary: null }, '', url);
        }
      }

      async loadRemaining() {
        let next = this.grid.dataset.nextPage;
        try {
          const known = new Set(this.cards.map(card => card.element.dataset.articleId));
          while (next) {
            const url = new URL(next, window.location.href);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Fabric library could not be loaded');
            const document = new DOMParser().parseFromString(await response.text(), 'text/html');
            const grid = document.querySelector('fabric-explorer [data-results]');
            if (!grid) throw new Error('Fabric library not found');
            for (const card of grid.querySelectorAll('[data-fabric-card]')) {
              if (known.has(card.dataset.articleId)) continue;
              known.add(card.dataset.articleId);
              this.grid.append(card);
            }
            next = grid.dataset.nextPage;
          }
          this.enableFilters();
        } catch (error) {
          if (error.name !== 'AbortError') this.readCards();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-discovery')) {
    customElements.define('home-discovery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.panels = Array.from(this.querySelectorAll('[data-home-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[data-home-choice]'));
        this.actions = Array.from(this.querySelectorAll('[data-home-action]'));
        this.tablist = this.querySelector('[data-home-tabs]');
        this.stage = this.querySelector('.home-discovery__stage');
        if (!this.panels.length) { this.dataset.ready = 'true'; return; }
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 767px)');
        this.index = 0;
        this.visible = false;
        this.cyclePaused = this.motion.matches;
        this.cycleHover = false;
        this.tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
        });
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-home-choice]');
          if (tab && this.contains(tab)) {
            event.preventDefault();
            this.select(Number(tab.dataset.index), true, true);
          }
        }, { signal });
        this.tablist.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-home-choice]');
          if (!tab || event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = this.tabs.indexOf(tab);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.tabs.length - 1;
          else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(index, true, true);
          this.tabs[index].focus({ preventScroll: true });
        }, { signal });
        this.stage.addEventListener('pointerdown', event => this.startSwipe(event), { signal, passive: true });
        this.stage.addEventListener('pointermove', event => this.moveSwipe(event), { signal, passive: true });
        this.stage.addEventListener('pointerup', event => this.finishSwipe(event), { signal, passive: true });
        this.stage.addEventListener('pointercancel', event => this.cancelSwipe(event), { signal, passive: true });
        this.stage.addEventListener('lostpointercapture', event => this.cancelSwipe(event), { signal, passive: true });
        this.stage.addEventListener('click', event => {
          if (event.detail !== 0 && performance.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { signal, capture: true });
        for (const panel of this.panels) {
          const film = panel.querySelector('video');
          if (!film) continue;
          film.muted = true; film.defaultMuted = true; film.playsInline = true; film.controls = false;
          film.addEventListener('playing', () => this.syncFilm(panel), { signal });
          film.addEventListener('pause', () => this.syncFilm(panel), { signal });
          film.addEventListener('ended', () => this.syncFilm(panel), { signal });
          film.addEventListener('loadeddata', () => this.syncFilm(panel), { signal });
          film.addEventListener('canplay', () => this.syncPlayback(), { signal });
          film.addEventListener('error', () => this.syncFilm(panel), { signal });
        }
        document.addEventListener('visibilitychange', () => { this.syncPlayback(); this.syncCycle(); }, { signal });
        window.addEventListener('pageshow', () => { this.syncPlayback(); this.syncCycle(); }, { signal });
        this.addEventListener('touchend', () => this.syncPlayback(), { signal, passive: true });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.cyclePaused = true;
          this.syncPlayback(); this.syncCycle();
        }, { signal });
        this.mobile.addEventListener('change', () => { this.syncPlayback(); this.syncActions(); }, { signal });
        this.tablist.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.cycleHover = true; this.syncCycle(); } }, { signal });
        this.tablist.addEventListener('pointerleave', () => { this.cycleHover = false; this.syncCycle(); }, { signal });
        this.addEventListener('focusin', () => this.syncCycle(), { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => this.syncCycle()), { signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index, false);
        }, { signal });
        this.observer = new IntersectionObserver(entries => this.syncVisibility(entries), { threshold: [0, .2] });
        this.observer.observe(this);
        this.dataset.enhanced = 'true';
        this.activate(0, false);
        this.dataset.ready = 'true';
      }

      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        this.clearSwipe();
        this.observer?.disconnect();
        this.transition?.skipTransition();
        clearTimeout(this.cycleTimer);
        this.querySelectorAll('video').forEach(film => film.pause());
      }

      startSwipe(event) {
        this.clearSwipe();
        if (!event.isPrimary || event.pointerType !== 'touch' || !this.mobile.matches || this.panels.length < 2 || event.target.closest('a, button, input, select, textarea, [contenteditable]')) {
          this.syncCycle();
          return;
        }
        this.swipe = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, index: this.pendingIndex ?? this.index };
        this.stage.setPointerCapture(event.pointerId);
        this.syncCycle();
      }

      moveSwipe(event) {
        if (!this.swipe || event.pointerId !== this.swipe.pointerId) return;
        const x = Math.abs(event.clientX - this.swipe.x);
        const y = Math.abs(event.clientY - this.swipe.y);
        if (y > 12 && y > x) {
          this.clearSwipe();
          this.syncCycle();
        }
      }

      finishSwipe(event) {
        if (!this.swipe || event.pointerId !== this.swipe.pointerId) return;
        const swipe = this.clearSwipe();
        const x = event.clientX - swipe.x;
        const y = event.clientY - swipe.y;
        const threshold = Math.max(40, Math.min(80, this.stage.clientWidth * .12));
        if (Math.abs(x) >= threshold && Math.abs(x) > Math.abs(y) * 1.35) {
          this.suppressClickUntil = performance.now() + 400;
          this.select((swipe.index + (x < 0 ? 1 : -1) + this.panels.length) % this.panels.length, true, true);
        } else this.syncCycle();
      }

      cancelSwipe(event) {
        if (!this.swipe || event.pointerId !== this.swipe.pointerId) return;
        this.clearSwipe();
        this.syncCycle();
      }

      clearSwipe() {
        const swipe = this.swipe;
        this.swipe = null;
        if (swipe && this.stage.hasPointerCapture(swipe.pointerId)) this.stage.releasePointerCapture(swipe.pointerId);
        return swipe;
      }

      select(index, animate, manual = false) {
        if (manual) { this.cyclePaused = true; this.syncCycle(); }
        if (!this.panels[index] || index === (this.pendingIndex ?? this.index)) return;
        this.pendingIndex = index;
        const request = this.request = (this.request || 0) + 1;
        this.transition?.skipTransition();
        const update = () => {
          if (request === this.request) {
            this.activate(index, true);
            this.pendingIndex = null;
          }
        };
        if (animate && this.mobile.matches && document.startViewTransition && !this.motion.matches) {
          this.transition = document.startViewTransition(update);
          this.transition.finished.catch(() => {});
        } else update();
      }

      activate(index, revealTab) {
        this.index = index;
        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.dataset.active = String(active);
          panel.inert = !active;
          panel.setAttribute('aria-hidden', String(!active));
          this.tabs[i].dataset.active = String(active);
          this.tabs[i].setAttribute('aria-selected', String(active));
          this.tabs[i].tabIndex = active ? 0 : -1;
        });
        if (revealTab && this.tablist.scrollWidth > this.tablist.clientWidth) {
          const tab = this.tabs[index];
          const left = Math.max(0, tab.offsetLeft - (this.tablist.clientWidth - tab.offsetWidth) / 2);
          this.tablist.scrollTo({ left, behavior: this.motion.matches ? 'instant' : 'smooth' });
        }
        this.syncPlayback();
        this.syncCycle();
        this.syncActions();
      }

      syncActions() {
        this.actions?.forEach((action, i) => {
          const active = i === this.index && !this.mobile.matches;
          action.dataset.active = String(active);
          action.setAttribute('aria-hidden', String(!active));
          const link = action.querySelector('a');
          if (link) link.tabIndex = active ? 0 : -1;
        });
      }

      syncCycle() {
        clearTimeout(this.cycleTimer);
        if (this.dataset.cycle !== 'true' || this.cyclePaused || this.cycleHover || this.swipe || !this.visible || document.hidden || this.querySelector(':focus-visible') || this.motion.matches || this.panels.length < 2) return;
        const interval = Math.max(5, Number(this.dataset.cycleInterval) || 7) * 1000;
        this.cycleTimer = setTimeout(() => this.select((this.index + 1) % this.panels.length, true), interval);
      }

      syncVisibility(entries) {
        this.visible = entries.at(-1).intersectionRatio >= .2;
        this.syncPlayback();
        this.syncCycle();
      }

      loadFilm(film) {
        const sources = Array.from(film.querySelectorAll('source[data-src]'));
        if (!sources.length) return true;
        const viewport = this.mobile.matches ? 'mobile' : 'desktop';
        if (film.dataset.viewport === viewport && film.getAttribute('src')) return true;
        const available = sources.filter(source => source.dataset.viewport === viewport);
        const stream = available.find(source => source.dataset.format === 'm3u8' && film.canPlayType(source.type));
        const mp4 = available.filter(source => source.dataset.format === 'mp4').sort((a, b) => Number(a.dataset.height) - Number(b.dataset.height));
        const budget = this.mobile.matches ? 1280 : 1080;
        const source = stream || mp4.filter(source => Number(source.dataset.height) <= budget).at(-1) || mp4[0];
        if (!source) return false;
        film.pause();
        film.dataset.filmReady = 'false';
        film.dataset.viewport = viewport;
        film.src = source.dataset.src;
        film.load();
        return true;
      }

      syncPlayback() {
        this.panels.forEach((panel, i) => {
          const film = panel.querySelector('video');
          if (!film) return;
          film.autoplay = i === this.index && this.visible && !document.hidden && !this.motion.matches;
          if (film.autoplay) {
            if (!this.loadFilm(film)) { film.autoplay = false; this.syncFilm(panel); return; }
            film.autoplay = true;
            if (film.paused) {
              const source = film.src;
              film.play().catch(() => { if (film.src === source) this.syncFilm(panel); });
            }
          } else film.pause();
          this.syncFilm(panel);
        });
      }

      syncFilm(panel) {
        const film = panel.querySelector('video');
        if (film.paused || film.ended || film.error) film.autoplay = false;
        film.dataset.filmReady = String(film.autoplay && !film.paused && !film.ended && film.readyState >= 2 && !film.error);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-feature')) {
    customElements.define('home-feature', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-home-booking]');
          if (link && this.contains(link)) this.openBooking(event, link);
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() { this.controller?.abort(); this.controller = null; }

      async openBooking(event, link) {
        event.preventDefault();
        if (link.getAttribute('aria-busy') === 'true') return;
        link.setAttribute('aria-busy', 'true');
        try {
          if (!document.getElementById('calendly-widget-css')) {
            const css = document.createElement('link');
            css.id = 'calendly-widget-css'; css.rel = 'stylesheet';
            css.href = 'https://assets.calendly.com/assets/external/widget.css';
            document.head.appendChild(css);
          }
          if (!window.Calendly?.initPopupWidget) {
            await new Promise((resolve, reject) => {
              let script = document.getElementById('calendly-widget-js');
              const timeout = setTimeout(() => reject(new Error('Booking unavailable')), 8000);
              const done = () => { clearTimeout(timeout); resolve(); };
              const fail = () => { clearTimeout(timeout); reject(new Error('Booking unavailable')); };
              if (!script) {
                script = document.createElement('script'); script.id = 'calendly-widget-js'; script.async = true;
                script.src = 'https://assets.calendly.com/assets/external/widget.js';
                script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true });
                document.head.appendChild(script);
              } else {
                script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true });
              }
            });
          }
          if (!window.Calendly?.initPopupWidget) throw new Error('Booking unavailable');
          window.Calendly.initPopupWidget({ url: link.href });
        } catch (_) { window.location.assign(link.href); }
        finally { link.removeAttribute('aria-busy'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-section-next')) {
    customElements.define('home-section-next', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('a');
          if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const url = new URL(link.href);
          if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
          const target = document.getElementById(url.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
          if (event.detail === 0) target.querySelector('[aria-selected="true"]')?.focus({ preventScroll: true });
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-editorial-layout')) {
    customElements.define('product-editorial-layout', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        const root = this.closest('[data-editorial-product="true"][data-product-mode="rtw"]');
        const form = this.querySelector('.product-form');
        if (!root || !form) return;
        // A tall form must remain fully readable, even on a short screen.
        this.observer = new ResizeObserver(() => {
          this.style.setProperty('--product-info-height', `${Math.ceil(form.getBoundingClientRect().height)}px`);
        });
        this.observer.observe(form);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mens-collection-controls"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mens-collection-controls')) {
    customElements.define('mens-collection-controls', class extends HTMLElement {
      connectedCallback() {
        this.onClick = event => {
          const link = event.target.closest('a[data-collection-update], #collection_pagination a');
          if (!link || (!this.contains(link) && !link.closest('#collection_root')) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const url = new URL(link.href);
          if (url.origin !== location.origin) return;
          event.preventDefault();
          this.update(url, { focusId: link.id, push: true });
        };
        this.onChange = event => {
          if (!event.target.matches('input[type="checkbox"], input[type="radio"]')) return;
          const form = this.querySelector('form');
          const url = new URL(form.action);
          url.search = new URLSearchParams(new FormData(form)).toString();
          const sort = event.target.name === 'sort_by';
          const keepFilter = sort ? null : event.target.closest('details')?.dataset.filterDisclosure;
          this.update(url, { focusId: sort ? 'MenSortToggle' : event.target.id, push: true, keepFilter });
        };
        this.onSubmit = event => {
          event.preventDefault();
          const url = new URL(event.target.action);
          url.search = new URLSearchParams(new FormData(event.target)).toString();
          this.update(url, { push: true });
        };
        this.onPop = () => this.update(new URL(location.href), { push: false });
        this.onOutside = event => {
          this.querySelectorAll('details[open]').forEach(detail => { if (!detail.contains(event.target)) detail.open = false; });
        };
        this.onKey = event => {
          if (event.key !== 'Escape') return;
          const detail = event.target.closest('details[open]');
          if (detail) { detail.open = false; detail.querySelector('summary').focus(); }
        };
        this.onToggle = event => {
          if (event.target.tagName !== 'DETAILS' || !event.target.open) return;
          this.querySelectorAll('details[open]').forEach(detail => { if (detail !== event.target) detail.open = false; });
        };
        document.addEventListener('click', this.onClick);
        document.addEventListener('click', this.onOutside);
        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('toggle', this.onToggle, true);
        window.addEventListener('popstate', this.onPop);
      }
      disconnectedCallback() {
        this.controller?.abort();
        document.removeEventListener('click', this.onClick);
        document.removeEventListener('click', this.onOutside);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('submit', this.onSubmit);
        this.removeEventListener('keydown', this.onKey);
        this.removeEventListener('toggle', this.onToggle, true);
        window.removeEventListener('popstate', this.onPop);
      }
      async update(url, { focusId, push, keepFilter } = {}) {
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const collection = document.querySelector('#collection_root');
        const grid = collection?.querySelector('[data-body-grid]');
        if (!grid) { location.assign(url.href); return; }
        const currentUrl = new URL(location.href);
        for (const key of ['view', 'preview_theme_id']) {
          if (currentUrl.searchParams.has(key) && !url.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
        }
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-collection-count]').textContent = this.dataset.loading;
        grid.setAttribute('data-collection-loading', '');
        const requestUrl = new URL(url);
        requestUrl.hash = '';
        requestUrl.searchParams.set('sections', `${this.dataset.sectionId},${collection.dataset.sectionId}`);
        try {
          const response = await fetch(requestUrl, { signal: controller.signal });
          if (!response.ok) throw new Error('Collection request failed');
          const html = await response.json();
          const parser = new DOMParser();
          const controls = parser.parseFromString(html[this.dataset.sectionId] || '', 'text/html').querySelector('mens-collection-controls');
          const updatedCollection = parser.parseFromString(html[collection.dataset.sectionId] || '', 'text/html').querySelector('#collection_root');
          if (!controls || !updatedCollection?.querySelector('[data-body-grid]')) throw new Error('Collection sections unavailable');
          if (controller.signal.aborted || !this.isConnected) return;
          grid.innerHTML = updatedCollection.querySelector('[data-body-grid]').innerHTML;
          collection.querySelector('[data-body-pagination]').innerHTML = updatedCollection.querySelector('[data-body-pagination]').innerHTML;
          collection.querySelector('[data-body-pagination-link]')?.remove();
          const skipLink = updatedCollection.querySelector('[data-body-pagination-link]');
          if (skipLink) grid.before(skipLink);
          if (keepFilter) controls.querySelector(`[data-filter-disclosure="${keepFilter}"]`)?.setAttribute('open', '');
          if (push && url.href !== location.href) history.pushState({}, '', url);
          grid.removeAttribute('data-collection-loading');
          this.replaceWith(controls);
          requestAnimationFrame(() => {
            grid.querySelectorAll('[data-transition-container]').forEach(item => {
              window.dispatchEvent(new Event(`theme:transition:reload:${item.dataset.transitionContainer}`));
            });
            window.dispatchEvent(new Event(`theme:transition:reload:${collection.dataset.sectionId}`));
            window.dispatchEvent(new Event('theme:navigation:reloaded'));
            controls.scrollIntoView({ block: 'start', behavior: 'auto' });
            if (focusId) controls.querySelector(`#${CSS.escape(focusId)}`)?.focus({ preventScroll: true });
            else controls.querySelector('[data-collection-count]')?.focus({ preventScroll: true });
          });
        } catch (error) {
          if (error.name !== 'AbortError') location.assign(url.href);
        } finally {
          if (this.controller === controller) {
            this.removeAttribute('aria-busy');
            grid.removeAttribute('data-collection-loading');
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-material-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('service-material-feature')) {
    customElements.define('service-material-feature', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dialog = this.querySelector('dialog');
        this.dialog.addEventListener('close', () => { if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true }); }, { signal });
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-material-image]');
          if (!link || !this.contains(link) || !this.dialog.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.trigger = link;
          const image = document.createElement('img'); image.src = link.href; image.alt = link.dataset.imageAlt;
          this.querySelector('[data-material-enlarged]').replaceChildren(image);
          this.dialog.showModal();
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-visit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('service-process-position')) {
    customElements.define('service-process-position', class extends HTMLElement {
      connectedCallback() { document.querySelector('suits-service')?.moveProcess?.(); }
      disconnectedCallback() { this.source?.restoreProcess(); this.source = null; }
    });
  }
  if (!customElements.get('service-visit')) {
    customElements.define('service-visit', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-service-booking]');
          if (link && this.contains(link) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) this.openBooking(event, link);
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
      async openBooking(event, link) {
        const panel = document.querySelector('suits-service consultation-booking');
        if (panel?.open) { event.preventDefault(); panel.open(link); return; }
        event.preventDefault();
        if (link.getAttribute('aria-busy') === 'true') return;
        link.setAttribute('aria-busy', 'true');
        try {
          if (!document.getElementById('calendly-widget-css')) {
            const css = document.createElement('link'); css.id = 'calendly-widget-css'; css.rel = 'stylesheet'; css.href = 'https://assets.calendly.com/assets/external/widget.css'; document.head.appendChild(css);
          }
          if (!window.Calendly?.initPopupWidget) {
            await new Promise((resolve, reject) => {
              let script = document.getElementById('calendly-widget-js');
              const timeout = setTimeout(() => reject(new Error('Booking unavailable')), 8000);
              const done = () => { clearTimeout(timeout); resolve(); };
              const fail = () => { clearTimeout(timeout); reject(new Error('Booking unavailable')); };
              if (!script) {
                script = document.createElement('script'); script.id = 'calendly-widget-js'; script.async = true; script.src = 'https://assets.calendly.com/assets/external/widget.js';
                script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true }); document.head.appendChild(script);
              } else { script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true }); }
            });
          }
          if (!window.Calendly?.initPopupWidget) throw new Error('Booking unavailable');
          window.Calendly.initPopupWidget({ url: link.href });
        } catch (_) { window.location.assign(link.href); }
        finally { link.removeAttribute('aria-busy'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suit-fabrics"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('suit-fabrics')) {
    customElements.define('suit-fabrics', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.grid = this.querySelector('[data-loop-track]'); this.carousel = this.querySelector('editorial-carousel');
        window.addEventListener('resize', () => { this.grid.style.minHeight = ''; }, { signal });
        this.buttons = Array.from(this.querySelectorAll('[data-fabric-material]'));
        this.material = '';
        this.dialog = this.querySelector('dialog');
        this.dialog?.addEventListener('close', () => { if (this.imageTrigger?.isConnected) this.imageTrigger.focus({ preventScroll: true }); }, { signal });
        this.addEventListener('click', event => {
          const filter = event.target.closest('[data-fabric-material]');
          if (filter && this.material !== filter.dataset.fabricMaterial) { this.material = filter.dataset.fabricMaterial; this.filter(true); }
          const imageLink = event.target.closest('[data-fabric-image]');
          if (imageLink && this.dialog?.showModal && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault(); this.imageTrigger = imageLink;
            const image = document.createElement('img'); image.src = imageLink.href; image.alt = imageLink.dataset.imageAlt;
            this.querySelector('[data-fabric-enlarged]').replaceChildren(image); this.dialog.showModal();
          }
        }, { signal });
        const start = () => {
          this.loadObserver?.disconnect();
          customElements.whenDefined('editorial-carousel').then(() => { if (!signal.aborted) this.loadCards(); });
        };
        if (window.Shopify?.designMode) start();
        else {
          this.loadObserver = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) start(); }, { rootMargin: '600px 0px' });
          this.loadObserver.observe(this);
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.loadObserver?.disconnect(); this.filterAnimation?.cancel(); }
      async loadCards() {
        let next = this.grid.dataset.nextPage;
        try {
          while (next) {
            const url = new URL(next, location.href); url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Fabric selection unavailable');
            const page = new DOMParser().parseFromString(await response.text(), 'text/html');
            const grid = page.querySelector('suit-fabrics [data-loop-track]');
            if (!grid) throw new Error('Fabric selection unavailable');
            const known = new Set(Array.from(this.grid.children, card => card.dataset.articleId));
            for (const card of grid.children) if (!known.has(card.dataset.articleId)) this.grid.append(card);
            next = grid.dataset.nextPage;
          }
          this.querySelector('[data-fabric-pagination]')?.setAttribute('hidden', '');
          this.cards = Array.from(this.grid.children).filter(card => !card.hasAttribute('data-loop-clone'));
          this.buttons.forEach(button => { button.hidden = !!button.dataset.fabricMaterial && !this.cards.some(card => card.dataset.materials.split(',').includes(button.dataset.fabricMaterial)); });
          this.querySelector('[data-fabric-filters]').hidden = false; this.filter();
        } catch (error) { if (error.name !== 'AbortError') this.querySelector('[data-fabric-count]').textContent = ''; }
      }
      filter(animate = false) {
        this.filterAnimation?.cancel();
        const soften = animate && this.classList.contains('suit-fabrics--books');
        if (soften) {
          this.grid.style.minHeight = '';
          this.grid.style.minHeight = `${this.grid.getBoundingClientRect().height}px`;
        }
        let count = 0;
        this.cards.forEach(card => { card.hidden = !!this.material && !card.dataset.materials.split(',').includes(this.material); if (!card.hidden) count++; });
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fabricMaterial === this.material)));
        this.querySelector('[data-fabric-count]').textContent = count === 1 ? this.dataset.singleCount : this.dataset.countTemplate.replace('__COUNT__', count);
        this.querySelector('[data-fabric-empty]').hidden = count > 0;
        this.carousel.setItems(this.cards.filter(card => !card.hidden));
        if (soften && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.filterAnimation = this.grid.animate([{ opacity: .35 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suit-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('suit-shop')) {
    customElements.define('suit-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController(); const signal = this.controller.signal;
        this.track = this.querySelector('[data-shop-track]');
        this.buttons = Array.from(this.querySelectorAll('[data-shop-material]'));
        this.material = ''; this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.addEventListener('click', event => {
          const filter = event.target.closest('[data-shop-material]');
          if (filter) { this.material = filter.dataset.shopMaterial; this.build(); }
          const direction = event.target.closest('[data-shop-direction]');
          if (direction) this.advance(Number(direction.dataset.shopDirection));
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (!this.products || event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({ left: this.cycleWidth + (event.key === 'End' ? Math.max(0, this.filtered.length - this.columns) * this.step : 0), behavior: 'instant' });
          else this.advance(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.normalize(); });
        }, { signal, passive: true });
        this.observer = new ResizeObserver(() => {
          if (!this.products) return;
          const columns = Number(getComputedStyle(this).getPropertyValue('--suit-shop-columns'));
          if (columns !== this.columns) this.build(); else this.measure();
        }); this.observer.observe(this.track);
        if (window.Shopify?.designMode) this.loadProducts();
        else {
          this.loadObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { this.loadObserver.disconnect(); this.loadProducts(); }
          }, { rootMargin: '600px 0px' });
          this.loadObserver.observe(this);
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); this.loadObserver?.disconnect(); if (this.frame) cancelAnimationFrame(this.frame); }
      async loadProducts() {
        let next = this.track.dataset.nextPage;
        try {
          while (next) {
            const url = new URL(next, location.href); url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Suit collection unavailable');
            const page = new DOMParser().parseFromString(await response.text(), 'text/html'); const track = page.querySelector('suit-shop [data-shop-track]');
            if (!track) throw new Error('Suit collection unavailable');
            const known = new Set(Array.from(this.track.children, card => card.dataset.productId));
            for (const card of track.children) if (!known.has(card.dataset.productId)) this.track.append(card);
            next = track.dataset.nextPage;
          }
          this.querySelector('[data-shop-pagination]')?.setAttribute('hidden', '');
          this.products = Array.from(this.track.children);
          this.buttons.forEach(button => { button.hidden = !!button.dataset.shopMaterial && !this.products.some(card => card.dataset.materials.split(',').includes(button.dataset.shopMaterial)); });
          this.querySelector('[data-shop-filters]').hidden = false; this.dataset.ready = 'true'; this.build();
        } catch (error) { if (error.name !== 'AbortError') this.dataset.ready = 'false'; }
      }
      build() {
        this.columns = Number(getComputedStyle(this).getPropertyValue('--suit-shop-columns'));
        this.filtered = this.products.filter(card => !this.material || card.dataset.materials.split(',').includes(this.material));
        this.looping = this.filtered.length > this.columns;
        const fragment = document.createDocumentFragment();
        const cloneCycle = () => {
          for (const card of this.filtered) {
            const clone = card.cloneNode(true); clone.dataset.shopClone = 'true'; clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a').forEach(link => link.tabIndex = -1); fragment.append(clone);
          }
        };
        if (this.looping) cloneCycle();
        this.filtered.forEach(card => fragment.append(card));
        if (this.looping) cloneCycle();
        this.track.replaceChildren(fragment); this.measure();
        this.track.scrollTo({ left: this.looping ? this.cycleWidth : 0, behavior: 'instant' });
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.shopMaterial === this.material)));
        this.querySelector('[data-shop-count]').textContent = this.dataset.countTemplate.replace('__COUNT__', this.filtered.length);
        this.querySelector('[data-shop-navigation]').hidden = !this.looping;
        this.querySelector('[data-shop-empty]').hidden = this.filtered.length > 0;
      }
      measure() {
        const card = this.track.firstElementChild;
        this.step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap) : 0;
        this.cycleWidth = this.looping ? this.step * this.filtered.length : 0;
        this.normalize();
      }
      normalize() {
        if (!this.looping || !this.cycleWidth) return;
        let left = this.track.scrollLeft;
        if (left < this.cycleWidth * .5) left += this.cycleWidth;
        else if (left > this.cycleWidth * 1.5) left -= this.cycleWidth;
        if (Math.abs(left - this.track.scrollLeft) > 1) this.track.scrollTo({ left, behavior: 'instant' });
      }
      advance(direction) {
        if (!this.looping) return;
        this.track.scrollBy({ left: direction * this.step, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suits-service"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('service-image-gallery')) {
    customElements.define('service-image-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.mobile = matchMedia('(max-width: 767px)');
        this.index = 0;
        this.addEventListener('pointerdown', event => this.begin(event), { signal, passive: true });
        this.addEventListener('pointermove', event => this.move(event), { signal, passive: false });
        this.addEventListener('pointerup', event => this.finish(event), { signal });
        this.addEventListener('pointercancel', event => this.finish(event, true), { signal });
        this.addEventListener('lostpointercapture', event => {
          // Ignore the image's bubbled capture loss when this gallery takes over.
          if (event.target === this) this.finish(event, true);
        }, { signal });
        this.addEventListener('dragstart', event => { if (this.mobile.matches) event.preventDefault(); }, { signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-gallery-step]');
          if (button && this.mobile.matches) this.select(this.index + Number(button.dataset.galleryStep));
        }, { signal });
        this.addEventListener('keydown', event => {
          if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.select(event.key === 'Home' ? 0 : event.key === 'End' ? this.frames.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        this.mobile.addEventListener('change', () => this.select(this.index), { signal });
        this.resizeObserver = new ResizeObserver(() => this.select(this.index));
        this.resizeObserver.observe(this);
        this.select(0);
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        this.resizeObserver?.disconnect();
      }
      select(index) {
        this.frames = [...this.querySelectorAll('figure')];
        if (!this.frames.length) return;
        this.gesture = null;
        this.dataset.dragging = 'false';
        this.index = Math.max(0, Math.min(this.frames.length - 1, index));
        this.dataset.galleryReady = 'true';
        this.scrollLeft = 0;
        this.style.setProperty('--gallery-position', `${this.mobile.matches ? -this.offset(this.index) : 0}px`);
        this.frames.forEach((frame, i) => {
          if (this.mobile.matches) frame.setAttribute('aria-hidden', String(i !== this.index));
          else frame.removeAttribute('aria-hidden');
        });
        this.querySelectorAll('[data-gallery-step]').forEach(button => {
          button.disabled = Number(button.dataset.galleryStep) < 0 ? this.index === 0 : this.index === this.frames.length - 1;
        });
        const count = this.querySelector('[data-gallery-count]');
        if (count) count.textContent = `${this.index + 1} / ${this.frames.length}`;
      }
      offset(index) { return this.frames[index].offsetLeft - this.frames[0].offsetLeft; }
      begin(event) {
        if (!this.mobile.matches || !this.frames?.length || event.isPrimary === false || (event.button != null && event.button !== 0) || event.target.closest('button')) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, time: event.timeStamp, axis: null };
      }
      move(event) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        if (!gesture.axis) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          if (Math.abs(dy) >= Math.abs(dx)) { this.gesture = null; return; }
          gesture.axis = 'x';
          this.setPointerCapture?.(gesture.id);
          this.dataset.dragging = 'true';
        }
        event.preventDefault();
        const edge = this.index === 0 && dx > 0 || this.index === this.frames.length - 1 && dx < 0;
        this.style.setProperty('--gallery-position', `${-this.offset(this.index) + dx * (edge ? .2 : 1)}px`);
      }
      finish(event, cancelled = false) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        this.gesture = null;
        const dx = event.clientX - gesture.x;
        const velocity = Math.abs(dx) / Math.max(1, event.timeStamp - gesture.time);
        const advance = !cancelled && gesture.axis === 'x' && (Math.abs(dx) >= 48 || Math.abs(dx) >= 14 && velocity >= .35);
        this.select(this.index + (advance ? dx < 0 ? 1 : -1 : 0));
        if (this.hasPointerCapture?.(gesture.id)) this.releasePointerCapture(gesture.id);
      }
    });
  }
  if (!customElements.get('service-style-preview')) {
    customElements.define('service-style-preview', class extends HTMLElement {
      connectedCallback() {
        this.results = this.querySelector('[data-style-preview-results]');
        this.status = this.querySelector('[data-style-preview-status]');
        if (!this.observer && !this.loaded) {
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(() => this.load(), { rootMargin: '100px' });
            this.observer.observe(this);
          } else this.load();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.observer = null;
      }
      async load() {
        const panel = this.closest('[data-suit-panel]');
        if (this.loaded || this.controller || !this.isConnected || panel?.dataset.active !== 'true') return;
        const bounds = this.getBoundingClientRect();
        if (bounds.bottom < -100 || bounds.top > innerHeight + 100) return;
        this.controller = new AbortController();
        const controller = this.controller;
        this.dataset.state = 'loading';
        this.results.setAttribute('aria-busy', 'true');
        this.status.hidden = false;
        this.querySelector('[data-style-preview-loading]').hidden = false;
        this.querySelector('[data-style-preview-error]').hidden = true;
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const url = new URL(this.dataset.url, location.origin);
          if (url.origin !== location.origin || !/\/collections\/[^/]+\/?$/.test(url.pathname)) throw new Error('Invalid collection');
          url.hash = '';
          url.searchParams.set('view', 'service-preview');
          url.searchParams.delete('page');
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Collection unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = document.querySelector('[data-style-preview-response]');
          if (!result || !this.isConnected) throw new Error('Missing collection preview');
          if (this.controller !== controller) return;
          this.results.replaceChildren(...result.childNodes);
          this.loaded = true;
          this.dataset.state = 'ready';
          this.status.hidden = true;
          this.observer?.disconnect();
        } catch {
          if (this.isConnected && this.controller === controller) {
            this.dataset.state = 'error';
            this.querySelector('[data-style-preview-loading]').hidden = true;
            this.querySelector('[data-style-preview-error]').hidden = false;
          }
        } finally {
          clearTimeout(timeout);
          if (this.controller === controller) {
            this.results.setAttribute('aria-busy', 'false');
            this.controller = null;
          }
        }
      }
    });
  }
  if (!customElements.get('suits-service')) {
    customElements.define('suits-service', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.panels = Array.from(this.querySelectorAll('[data-suit-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[data-suit-choice]'));
        this.chapters = Array.from(this.querySelectorAll('[data-service-chapter]'));
        this.tablist = this.querySelector('[data-suit-tabs]');
        this.stage = this.querySelector('.suits-service__panels');
        this.track = this.querySelector('.suits-service__track');
        this.process = this.querySelector('[data-service-process]');
        this.processHome = document.createComment('Service process original position');
        this.process?.before(this.processHome);
        this.moveProcess();
        this.process?.addEventListener('click', event => {
          const link = event.target.closest('[data-suits-booking]');
          if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.stopPropagation(); this.openBooking(event, link);
          }
        }, { signal });
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 767px)');
        this.visible = new Set();
        this.films = [];
        this.index = 0;
        this.returnTop = this.querySelector('[data-suits-return]');
        this.tablist?.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel'); this.panels[index].setAttribute('aria-labelledby', tab.id); this.panels[index].tabIndex = 0;
        });
        this.addEventListener('click', event => {
          const begin = event.target.closest('.suits-service__begin');
          if (begin && this.contains(begin) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            const selection = this.querySelector('.suits-service__selection');
            if (selection) {
              event.preventDefault();
              selection.scrollIntoView({ block: 'start', behavior: this.motion.matches ? 'instant' : 'smooth' });
            }
          }
          const step = event.target.closest('[data-suit-step]');
          if (step && this.contains(step)) this.select((this.index + Number(step.dataset.suitStep) + this.panels.length) % this.panels.length, true);
          const chapter = event.target.closest('[data-service-chapter]');
          if (chapter && this.contains(chapter)) {
            const index = Number(chapter.dataset.serviceChapter);
            this.select(index, true, false, index === this.index && !this.chapterClosed);
            const bounds = chapter.getBoundingClientRect();
            if (bounds.top < 0 || bounds.bottom > window.innerHeight) chapter.scrollIntoView({ block: 'start', behavior: this.motion.matches ? 'instant' : 'smooth' });
          }
          const tab = event.target.closest('[data-suit-choice]');
          if (tab && this.contains(tab) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault(); this.select(Number(tab.dataset.suitChoice), true);
          }
          const top = event.target.closest('[data-suits-return]');
          if (top && this.contains(top)) {
            event.preventDefault(); this.querySelector('.suits-service__hero').scrollIntoView({ behavior: this.motion.matches ? 'instant' : 'smooth' });
          }
          const booking = event.target.closest('[data-suits-booking]');
          if (booking && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) this.openBooking(event, booking);
        }, { signal });
        this.track?.addEventListener('scroll', () => {
          if (!this.mobile.matches || this.dataset.modelStyles === 'true' || this.dataset.mobileChapters === 'true' || this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (this.scrollTarget != null) {
              if (Math.abs(this.track.scrollLeft - this.scrollTarget * this.track.clientWidth) < 2) this.scrollTarget = null;
              else return;
            }
            if (index !== this.index) this.select(index, true, true);
          });
        }, { signal, passive: true });
        this.mobile.addEventListener('change', () => {
          this.track?.scrollTo({ left: this.mobile.matches && this.dataset.modelStyles !== 'true' && this.dataset.mobileChapters !== 'true' ? this.index * this.track.clientWidth : 0, behavior: 'instant' });
          if (this.chapters.length) this.select(this.index, false, false, this.chapterClosed);
        }, { signal });
        for (const type of ['pointerdown', 'wheel']) this.track?.addEventListener(type, () => { this.scrollTarget = null; }, { signal, passive: true });
        this.tablist?.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-suit-choice]');
          if (!tab || event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const current = this.tabs.indexOf(tab);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(index, true); this.tabs[index].focus({ preventScroll: true });
        }, { signal });
        this.filmObserver = new IntersectionObserver(entries => {
          for (const entry of entries) entry.isIntersecting ? this.visible.add(entry.target) : this.visible.delete(entry.target);
          this.syncPlayback();
        }, { threshold: .15 });
        this.querySelectorAll('video').forEach(film => this.setupFilm(film));
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        window.addEventListener('pageshow', () => this.syncPlayback(), { signal });
        this.addEventListener('touchend', () => this.syncPlayback(), { signal, passive: true });
        this.motion.addEventListener('change', () => this.syncPlayback(), { signal });
        document.addEventListener('shopify:block:select', event => {
          const editorial = [...this.querySelectorAll('[data-editorial-model-id]')].find(slide => slide.dataset.editorialModelId === event.detail.blockId);
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId || editorial && panel.contains(editorial));
          if (index >= 0) this.select(index, false);
          if (editorial) {
            const models = editorial.closest('dress-models');
            models?.select([...models.querySelectorAll('[data-model-slide]')].indexOf(editorial), false);
          }
        }, { signal });
        this.heroObserver = new IntersectionObserver(entries => { this.returnTop.hidden = entries[0].isIntersecting; }, { threshold: 0 });
        this.heroObserver.observe(this.querySelector('.suits-service__hero'));
        this.previewBar = document.querySelector('#PBarNextFrame');
        this.resizeObserver = new ResizeObserver(() => this.syncPreview());
        if (this.previewBar) this.resizeObserver.observe(this.previewBar);
        window.addEventListener('resize', () => this.syncPreview(), { signal });
        this.select(0, false); this.dataset.enhanced = 'true'; this.dataset.ready = 'true'; this.syncPreview();
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        cancelAnimationFrame(this.scrollFrame);
        this.restoreProcess(); this.processHome?.remove();
        this.filmObserver?.disconnect(); this.heroObserver?.disconnect(); this.resizeObserver?.disconnect();
        this.films?.forEach(film => film.pause());
      }
      moveProcess() {
        const slot = document.querySelector('service-process-position');
        if (slot && this.process && this.processHome) { slot.append(this.process); slot.source = this; }
      }
      restoreProcess() {
        if (this.processHome?.parentNode && this.process) this.processHome.after(this.process);
      }
      select(index, reveal, fromScroll = false, collapse = false) {
        if (!this.panels[index]) return;
        this.index = index;
        this.chapterClosed = collapse;
        const chapterMode = this.mobile.matches && this.chapters.length > 0;
        if (this.mobile.matches && this.dataset.modelStyles !== 'true' && !chapterMode && !fromScroll) {
          this.scrollTarget = index;
          this.track?.scrollTo({ left: index * this.track.clientWidth, behavior: reveal && !this.motion.matches ? 'smooth' : 'instant' });
        }
        const template = this.panels[index].querySelector('template[data-suit-media]');
        if (template) {
          template.replaceWith(template.content);
          this.panels[index].querySelector('noscript')?.remove();
          if (reveal) this.panels[index].querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
          this.panels[index].querySelectorAll('video').forEach(film => this.setupFilm(film));
        }
        this.panels.forEach((panel, i) => {
          const active = i === index && !(chapterMode && collapse); panel.dataset.active = String(active); panel.inert = !active; panel.setAttribute('aria-hidden', String(!active));
          panel.setAttribute('role', chapterMode ? 'region' : 'tabpanel');
          panel.setAttribute('aria-labelledby', chapterMode ? this.chapters[i].id : this.tabs[i].id);
          this.chapters[i]?.setAttribute('aria-expanded', String(active));
          this.tabs[i].dataset.active = String(active); this.tabs[i].setAttribute('aria-selected', String(active)); this.tabs[i].tabIndex = active ? 0 : -1;
        });
        if (reveal && this.tablist.scrollWidth > this.tablist.clientWidth) {
          const tab = this.tabs[index];
          this.tablist.scrollTo({ left: Math.max(0, this.tablist.scrollLeft + tab.getBoundingClientRect().left - this.tablist.getBoundingClientRect().left - (this.tablist.clientWidth - tab.offsetWidth) / 2), behavior: fromScroll || this.motion.matches ? 'instant' : 'smooth' });
        }
        this.syncPlayback();
        this.panels[index].querySelector('service-style-preview')?.load();
        for (const nearby of [index - 1, index + 1]) {
          const panel = this.panels[nearby];
          const pending = panel?.querySelector('template[data-suit-media]');
          if (pending) { pending.replaceWith(pending.content); panel.querySelector('noscript')?.remove(); panel.querySelectorAll('video').forEach(film => this.setupFilm(film)); }
          panel?.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
        }
      }
      setupFilm(film) {
        if (this.films.includes(film)) return;
        this.films.push(film);
        film.muted = true; film.defaultMuted = true; film.playsInline = true; film.controls = false;
        const signal = this.controller.signal;
        const region = film.closest('[data-suit-film-region]');
        this.filmObserver.observe(region);
        for (const event of ['playing', 'pause', 'ended', 'loadeddata']) film.addEventListener(event, () => {
          this.syncFilm(film);
        }, { signal });
        film.addEventListener('canplay', () => this.syncPlayback(), { signal });
        film.addEventListener('error', () => {
          if (film.dataset.format === 'm3u8' && film.dataset.fallback !== 'true') {
            film.dataset.fallback = 'true'; delete film.dataset.loaded;
            this.syncPlayback();
          }
          this.syncFilm(film);
        }, { signal });
      }
      syncModelFilms(models) {
        if (!this.controller || !this.filmObserver) return;
        models.querySelectorAll('video').forEach(film => this.setupFilm(film));
        this.syncPlayback();
      }
      loadFilm(film) {
        const viewport = this.mobile.matches ? 'mobile' : 'desktop';
        if (film.dataset.loaded === 'true' && (!film.dataset.viewport || film.dataset.viewport === viewport)) return true;
        const sources = Array.from(film.querySelectorAll('source[data-src]')).filter(source => !source.dataset.viewport || source.dataset.viewport === viewport);
        const hls = sources.find(source => source.dataset.format === 'm3u8' && film.canPlayType(source.type));
        const mp4 = sources.filter(source => source.dataset.format === 'mp4').sort((a, b) => Number(a.dataset.height) - Number(b.dataset.height));
        const suitable = mp4.filter(source => Number(source.dataset.height) <= (this.mobile.matches ? 720 : 1080));
        const source = (film.dataset.fallback !== 'true' && hls) || suitable.at(-1) || mp4[0] || sources.find(source => film.canPlayType(source.type));
        if (!source) return false;
        film.dataset.loaded = 'true'; film.dataset.format = source.dataset.format;
        if (source.dataset.viewport) film.dataset.viewport = viewport;
        film.dataset.playing = 'false';
        film.muted = true; film.defaultMuted = true; film.src = source.dataset.src; film.load();
        return true;
      }
      syncPlayback() {
        for (const film of this.films) {
          const region = film.closest('[data-suit-film-region]'); const panel = film.closest('[data-suit-panel]');
          const model = film.closest('[data-model-slide]');
          const active = (!panel || panel.dataset.active === 'true') && (!model || model.dataset.active === 'true');
          film.autoplay = active && this.visible.has(region) && !document.hidden && !this.motion.matches;
          if (film.autoplay) {
            if (!this.loadFilm(film)) {
              film.autoplay = false;
            }
            else if (film.paused) {
              film.autoplay = true;
              const source = film.src;
              film.play().catch(error => {
                if (film.src !== source || error.name === 'AbortError') return;
                this.syncFilm(film);
              });
            }
          }
          else film.pause();
          this.syncFilm(film);
        }
      }
      syncFilm(film) {
        if (film.paused || film.ended || film.error) film.autoplay = false;
        film.dataset.playing = String(film.autoplay && !film.paused && !film.ended && film.readyState >= 2 && !film.error);
      }
      syncPreview() {
        const bounds = this.previewBar?.getBoundingClientRect();
        const height = bounds && bounds.width > 0 && bounds.top < innerHeight ? Math.max(0, innerHeight - bounds.top) : 0;
        const toolbar = bounds && bounds.height > innerHeight / 2 ? 64 : Math.min(height, 100);
        this.style.setProperty('--service-preview-bottom', `${toolbar}px`);
      }
      async openBooking(event, link) {
        const panel = this.querySelector('consultation-booking');
        if (panel?.open) { event.preventDefault(); panel.open(link); return; }
        event.preventDefault();
        if (link.getAttribute('aria-busy') === 'true') return;
        link.setAttribute('aria-busy', 'true');
        try {
          if (!document.getElementById('calendly-widget-css')) {
            const css = document.createElement('link'); css.id = 'calendly-widget-css'; css.rel = 'stylesheet'; css.href = 'https://assets.calendly.com/assets/external/widget.css'; document.head.appendChild(css);
          }
          if (!window.Calendly?.initPopupWidget) {
            await new Promise((resolve, reject) => {
              let script = document.getElementById('calendly-widget-js');
              const timeout = setTimeout(() => reject(new Error('Booking unavailable')), 8000);
              const done = () => { clearTimeout(timeout); resolve(); };
              const fail = () => { clearTimeout(timeout); reject(new Error('Booking unavailable')); };
              if (!script) {
                script = document.createElement('script'); script.id = 'calendly-widget-js'; script.async = true; script.src = 'https://assets.calendly.com/assets/external/widget.js';
                script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true }); document.head.appendChild(script);
              } else { script.addEventListener('load', done, { once: true }); script.addEventListener('error', fail, { once: true }); }
            });
          }
          if (!window.Calendly?.initPopupWidget) throw new Error('Booking unavailable');
          window.Calendly.initPopupWidget({ url: link.href });
        } catch (_) { window.location.assign(link.href); }
        finally { link.removeAttribute('aria-busy'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
